let DATA_API_GOOGLE = {
  'lista-poligonos': [
    {
      ubigeo: '70101',
      name: 'JOSE BOTERIN',
      poligonos: [
        {lat: -12.05256445313486, lng: -77.12304782927824},
        {lat: -12.05327301894583, lng: -77.12359368601527},
        {lat: -12.05388529455999, lng: -77.12234635862123},
        {lat: -12.05448431590216, lng: -77.12157308729415},
        {lat: -12.05478520770218, lng: -77.12149267922676},
        {lat: -12.05519719869022, lng: -77.12187081379112},
        {lat: -12.05544522663079, lng: -77.12184804659769},
        {lat: -12.05545537693809, lng: -77.12207736380093},
        {lat: -12.05577490494655, lng: -77.1219251453003},
        {lat: -12.05458829336452, lng: -77.12078252768858},
        {lat: -12.05434313088018, lng: -77.12047880172196},
        {lat: -12.05413752915037, lng: -77.12009209260219},
        {lat: -12.05396822258458, lng: -77.1194318034862},
        {lat: -12.05385236208602, lng: -77.11799117188342},
        {lat: -12.05199722817705, lng: -77.11809198156102},
        {lat: -12.05203406498668, lng: -77.11914586045289},
        {lat: -12.0514907467587, lng: -77.11922800682613},
        {lat: -12.05141356336441, lng: -77.11918130868307},
        {lat: -12.05143273825557, lng: -77.11906872536721},
        {lat: -12.05118334313086, lng: -77.11906730511156},
        {lat: -12.05148738565393, lng: -77.12247603996296},
        {lat: -12.05177950431091, lng: -77.12244006634958},
        {lat: -12.05191221348306, lng: -77.12384103085168}
      ],
    },
    {
      ubigeo: '70101',
      name: 'CIUDADELA LA CHALACA',
      poligonos: [
        {lat: -12.05112905145141, lng: -77.13431276138178},
        {lat: -12.05146430152484, lng: -77.13371875258954},
        {lat: -12.05118581152744, lng: -77.13004206576974},
        {lat: -12.0477366486734, lng: -77.13082187648361},
        {lat: -12.0478443357475, lng: -77.13112883199},
        {lat: -12.04793602397837, lng: -77.13131371910671},
        {lat: -12.04814711777791, lng: -77.13148164640377},
        {lat: -12.04907054605822, lng: -77.13216632016109},
        {lat: -12.04929982685124, lng: -77.13313523758313},
        {lat: -12.04992003799825, lng: -77.13299602211065},
        {lat: -12.05023931982033, lng: -77.13433659103113},
        {lat: -12.05046717406361, lng: -77.13427104908543},
        {lat: -12.0504907847837, lng: -77.13446404158394}
      ],
    },
    {
      ubigeo: '70101',
      name: 'CHACARITAS',
      poligonos: [
        {
          lng: -77.1341469195065,
          lat: -12.05202057059937,
        },
        {
          lng: -77.13431531919812,
          lat: -12.05116292605984,
        },
        {
          lng: -77.13508958788398,
          lat: -12.04766949783613,
        },
        {
          lng: -77.13770575248907,
          lat: -12.04863876633536,
        },
        {
          lng: -77.13882584933664,
          lat: -12.04916342055819,
        },
        {
          lng: -77.13924315153079,
          lat: -12.04940503933545,
        },
        {
          lng: -77.13980857379153,
          lat: -12.04996078471138,
        },
        {
          lng: -77.1406275131933,
          lat: -12.05121810136138,
        },
        {
          lng: -77.13846562819799,
          lat: -12.05232648452134,
        },
        {
          lng: -77.13832696040167,
          lat: -12.05268362533476,
        },
        {
          lng: -77.13335866385889,
          lat: -12.05568897852636,
        },
      ],
    },
    {
      ubigeo: '70101',
      name: 'URB PLAYA RIMAC',
      poligonos: [
        {
          lng: -77.09733599573599,
          lat: -12.03558873869814,
        },
        {
          lng: -77.09742533699287,
          lat: -12.03550962030082,
        },
        {
          lng: -77.09778102886294,
          lat: -12.03574903724532,
        },
        {
          lng: -77.09869214140765,
          lat: -12.0359189250563,
        },
        {
          lng: -77.09953986677877,
          lat: -12.03582416218564,
        },
        {
          lng: -77.09927603511505,
          lat: -12.03724876988347,
        },
        {
          lng: -77.09911973402156,
          lat: -12.03939507942524,
        },
        {
          lng: -77.09710658985632,
          lat: -12.03879912603685,
        },
        {
          lng: -77.09676238088687,
          lat: -12.038588419787,
        },
        {
          lng: -77.09361035101611,
          lat: -12.03792998771298,
        },
        {
          lng: -77.09369031756172,
          lat: -12.0375047869662,
        },
        {
          lng: -77.09358717361351,
          lat: -12.03670923342962,
        },
        {
          lng: -77.09360859033983,
          lat: -12.03627120925771,
        },
        {
          lng: -77.09518836578178,
          lat: -12.03657352761975,
        },
        {
          lng: -77.09518689453843,
          lat: -12.03611276707822,
        },
        {
          lng: -77.09657996182914,
          lat: -12.03644293506023,
        },
        {
          lng: -77.09689239409111,
          lat: -12.03645857810113,
        },
        {
          lng: -77.09714917033521,
          lat: -12.03637762372421,
        },
        {
          lng: -77.0973577695048,
          lat: -12.0362527996915,
        },
        {
          lng: -77.09767765727787,
          lat: -12.03584675879617,
        },
      ],
    },
    {
      ubigeo: '70101',
      name: 'SARITA COLONIA',
      poligonos: [
        {
          lng: -77.13544228192778,
          lat: -12.02043479556934,
        },
        {
          lng: -77.1363749185813,
          lat: -12.02473980786588,
        },
        {
          lng: -77.12903056079196,
          lat: -12.02786586116018,
        },
        {
          lng: -77.13065575652864,
          lat: -12.024657989653,
        },
        {
          lng: -77.13200628522246,
          lat: -12.02228620935939,
        },
        {
          lng: -77.13196431669388,
          lat: -12.02168083139431,
        },
      ],
    },
    {
      ubigeo: '70101',
      name: 'ACAPULCO',
      poligonos: [
        {
          lng: -77.13709067870568,
          lat: -12.01988391850434,
        },
        {
          lng: -77.13719581744819,
          lat: -12.01984506624921,
        },
        {
          lng: -77.13808698890142,
          lat: -12.02278632850649,
        },
        {
          lng: -77.13809635295382,
          lat: -12.02328959469273,
        },
        {
          lng: -77.1378771992689,
          lat: -12.02412707058956,
        },
        {
          lng: -77.13712332966102,
          lat: -12.02448253295279,
        },
        {
          lng: -77.13679919136145,
          lat: -12.02226959973409,
        },
        {
          lng: -77.13699164532595,
          lat: -12.02223796899818,
        },
        {
          lng: -77.13683950607027,
          lat: -12.02142451488269,
        },
        {
          lng: -77.13644860112501,
          lat: -12.0214912143402,
        },
        {
          lng: -77.13606536390988,
          lat: -12.01953998054279,
        },
        {
          lng: -77.136971367808,
          lat: -12.0192966379315,
        },
      ],
    },
    {
      ubigeo: '70101',
      name: 'TIWINZA',
      poligonos: [
        {
          lng: -77.13786861056903,
          lat: -12.02413919526188,
        },
        {
          lng: -77.13808335547503,
          lat: -12.0232786385248,
        },
        {
          lng: -77.13807461670385,
          lat: -12.02280033109363,
        },
        {
          lng: -77.1371844661841,
          lat: -12.01987005159312,
        },
        {
          lng: -77.13883482566885,
          lat: -12.01925773213518,
        },
        {
          lng: -77.14059330672106,
          lat: -12.01879082016452,
        },
        {
          lng: -77.14069332255548,
          lat: -12.0190492199863,
        },
        {
          lng: -77.14217671359835,
          lat: -12.01847087746636,
        },
        {
          lng: -77.14309544026403,
          lat: -12.02170806510031,
        },
      ],
    },
    {
      ubigeo: '70101',
      name: 'GAMBETA BAJA',
      poligonos: [
        {
          lng: -77.11715466711102,
          lat: -12.04041947690495,
        },
        {
          lng: -77.11743106707146,
          lat: -12.04240289613893,
        },
        {
          lng: -77.11615393479843,
          lat: -12.0425571251712,
        },
        {
          lng: -77.11597354330623,
          lat: -12.04279866999261,
        },
        {
          lng: -77.11599202562925,
          lat: -12.04323296517292,
        },
        {
          lng: -77.11576150854746,
          lat: -12.04322832627117,
        },
        {
          lng: -77.11343328517275,
          lat: -12.04470810213918,
        },
        {
          lng: -77.11258272416636,
          lat: -12.04141984792741,
        },
        {
          lng: -77.10920762830769,
          lat: -12.04227416093298,
        },
        {
          lng: -77.10862207850708,
          lat: -12.04222831876138,
        },
        {
          lng: -77.1078296051104,
          lat: -12.04215571452755,
        },
        {
          lng: -77.10784565998532,
          lat: -12.04200826284146,
        },
        {
          lng: -77.10849846340636,
          lat: -12.04205572841735,
        },
        {
          lng: -77.1090559126135,
          lat: -12.0420488789334,
        },
        {
          lng: -77.1097685164758,
          lat: -12.04192637645093,
        },
        {
          lng: -77.11601195850781,
          lat: -12.04037067961605,
        },
        {
          lng: -77.11664346227322,
          lat: -12.04027361650394,
        },
      ],
    },
    {
      ubigeo: '70101',
      name: 'MARISCAL RAMON CASTILLA',
      poligonos: [
        {
          lng: -77.12509367137248,
          lat: -12.03909246813842,
        },
        {
          lng: -77.1260601247851,
          lat: -12.041011933062,
        },
        {
          lng: -77.12685283042666,
          lat: -12.04064280664974,
        },
        {
          lng: -77.12651489510455,
          lat: -12.04429904053615,
        },
        {
          lng: -77.12528980257404,
          lat: -12.04427011778689,
        },
        {
          lng: -77.12210049698854,
          lat: -12.04465479558607,
        },
        {
          lng: -77.12132447509644,
          lat: -12.04201622415931,
        },
        {
          lng: -77.1208114602386,
          lat: -12.0399932639015,
        },
        {
          lng: -77.12471315091418,
          lat: -12.03851183219372,
        },
      ],
    },
    {
      ubigeo: '70101',
      name: 'PUERTO NUEVO',
      poligonos: [
        {
          lng: -77.1380773545202,
          lat: -12.04631796260512,
        },
        {
          lng: -77.13777967733712,
          lat: -12.04750616950645,
        },
        {
          lng: -77.13648991007975,
          lat: -12.04720664072306,
        },
        {
          lng: -77.13678597776467,
          lat: -12.04603253551972,
        },
      ],
    },
    {
      ubigeo: '150101',
      name: 'BARRIOS ALTOS',
      poligonos: [
        {
          lng: -77.02814653174657,
          lat: -11.70327233459019,
        },
        {
          lng: -77.03291012421137,
          lat: -11.70895874226238,
        },
        {
          lng: -77.03622170550295,
          lat: -11.71066840796155,
        },
        {
          lng: -77.04149298002608,
          lat: -11.71294631331127,
        },
        {
          lng: -77.04306753726829,
          lat: -11.71661406117544,
        },
        {
          lng: -77.03860312900787,
          lat: -11.72318690251138,
        },
        {
          lng: -77.0364166667892,
          lat: -11.73096960708352,
        },
        {
          lng: -77.03389272653125,
          lat: -11.73465150804972,
        },
        {
          lng: -77.03139052013967,
          lat: -11.73956298055296,
        },
        {
          lng: -77.03909250712512,
          lat: -11.75265562871457,
        },
        {
          lng: -77.04318419958362,
          lat: -11.75435485584795,
        },
        {
          lng: -77.04471376643147,
          lat: -11.75794811222856,
        },
        {
          lng: -77.05007617628502,
          lat: -11.76121686386898,
        },
        {
          lng: -77.05379835888462,
          lat: -11.76554148988128,
        },
        {
          lng: -77.05502325384727,
          lat: -11.77026752753975,
        },
        {
          lng: -77.0539919019262,
          lat: -11.77387784367084,
        },
        {
          lng: -77.05382413183843,
          lat: -11.77931801559115,
        },
        {
          lng: -77.05714127906353,
          lat: -11.78576588051055,
        },
        {
          lng: -77.06119384171892,
          lat: -11.78817175848958,
        },
        {
          lng: -77.06459296057007,
          lat: -11.78896515689567,
        },
        {
          lng: -77.06858936509522,
          lat: -11.79028653461648,
        },
        {
          lng: -77.07327308372814,
          lat: -11.79219826679818,
        },
        {
          lng: -77.07421536063252,
          lat: -11.79615732363777,
        },
        {
          lng: -77.07987601816666,
          lat: -11.79894351346486,
        },
        {
          lng: -77.0825274425327,
          lat: -11.80099261498088,
        },
        {
          lng: -77.09259576665336,
          lat: -11.80350425166394,
        },
        {
          lng: -77.09355293219582,
          lat: -11.80773697764818,
        },
        {
          lng: -77.09079708263323,
          lat: -11.81382064732527,
        },
        {
          lng: -77.09101463961547,
          lat: -11.81861386043686,
        },
        {
          lng: -77.09018922418798,
          lat: -11.82372277033055,
        },
        {
          lng: -77.08809964402911,
          lat: -11.82499131123629,
        },
        {
          lng: -77.08863769884975,
          lat: -11.83015769199457,
        },
        {
          lng: -77.08869907414878,
          lat: -11.8341265049602,
        },
        {
          lng: -77.08697519952435,
          lat: -11.83842543786111,
        },
        {
          lng: -77.08293352397268,
          lat: -11.84080210355708,
        },
        {
          lng: -77.076122086138,
          lat: -11.84677179473534,
        },
        {
          lng: -77.06420740713509,
          lat: -11.85184957810769,
        },
        {
          lng: -77.05947584101769,
          lat: -11.8582544465528,
        },
        {
          lng: -77.05792390767452,
          lat: -11.86538332063209,
        },
        {
          lng: -77.0593139057414,
          lat: -11.86874691304567,
        },
        {
          lng: -77.0552190148858,
          lat: -11.87455069250161,
        },
        {
          lng: -77.05592581996802,
          lat: -11.88558710747746,
        },
        {
          lng: -77.05422723740627,
          lat: -11.88960776950433,
        },
        {
          lng: -77.05084245433477,
          lat: -11.88715519350449,
        },
        {
          lng: -77.04676567940962,
          lat: -11.89327051241696,
        },
        {
          lng: -77.04808736258538,
          lat: -11.8960531674045,
        },
        {
          lng: -77.0460127254302,
          lat: -11.8976399228978,
        },
        {
          lng: -77.04344999935049,
          lat: -11.89715902527125,
        },
        {
          lng: -77.04232962899401,
          lat: -11.89456600371008,
        },
        {
          lng: -77.03958244119475,
          lat: -11.89687248078409,
        },
        {
          lng: -77.03382862369486,
          lat: -11.90690661092159,
        },
        {
          lng: -77.03063547319479,
          lat: -11.90999258072218,
        },
        {
          lng: -77.02310824249022,
          lat: -11.90835566249994,
        },
        {
          lng: -77.01990003545598,
          lat: -11.90553964109828,
        },
        {
          lng: -77.01393425896632,
          lat: -11.90305090518299,
        },
        {
          lng: -77.01160041264079,
          lat: -11.90403555878673,
        },
        {
          lng: -77.00585255337758,
          lat: -11.9040135607614,
        },
        {
          lng: -76.99993209491409,
          lat: -11.89974473447789,
        },
        {
          lng: -76.99610749473567,
          lat: -11.89910320868902,
        },
        {
          lng: -76.99282313679048,
          lat: -11.90074284267577,
        },
        {
          lng: -76.99019493269567,
          lat: -11.90029536553927,
        },
        {
          lng: -76.98731506111378,
          lat: -11.89636453718302,
        },
        {
          lng: -76.9831743929344,
          lat: -11.89383124436707,
        },
        {
          lng: -76.97720658732445,
          lat: -11.89162464336064,
        },
        {
          lng: -76.97429755229899,
          lat: -11.88941151205225,
        },
        {
          lng: -76.97066799606839,
          lat: -11.8849690938319,
        },
        {
          lng: -76.96608699620141,
          lat: -11.87796410646499,
        },
        {
          lng: -76.96332865825981,
          lat: -11.87434092038073,
        },
        {
          lng: -76.96085472968265,
          lat: -11.87197347994931,
        },
        {
          lng: -76.95652657791207,
          lat: -11.87025850888735,
        },
        {
          lng: -76.95480664272478,
          lat: -11.86766774125472,
        },
        {
          lng: -76.95237591887583,
          lat: -11.86550044691588,
        },
        {
          lng: -76.94730869027315,
          lat: -11.86259537440242,
        },
        {
          lng: -76.94194277352864,
          lat: -11.86091640576953,
        },
        {
          lng: -76.94092214357987,
          lat: -11.85707122269126,
        },
        {
          lng: -76.93724960146561,
          lat: -11.85131766697982,
        },
        {
          lng: -76.93452430233722,
          lat: -11.84576178896484,
        },
        {
          lng: -76.93401126856763,
          lat: -11.83717556077536,
        },
        {
          lng: -76.935545739863,
          lat: -11.8338909830242,
        },
        {
          lng: -76.93426825971703,
          lat: -11.8327232416948,
        },
        {
          lng: -76.93004185129739,
          lat: -11.8337219153786,
        },
        {
          lng: -76.92585986053707,
          lat: -11.83283344413388,
        },
        {
          lng: -76.92142857419805,
          lat: -11.83148728112488,
        },
        {
          lng: -76.91602728116125,
          lat: -11.83181034138924,
        },
        {
          lng: -76.91263955947423,
          lat: -11.8288254891172,
        },
        {
          lng: -76.90628647599117,
          lat: -11.82619032028452,
        },
        {
          lng: -76.9032772213492,
          lat: -11.82274045046477,
        },
        {
          lng: -76.90657221285296,
          lat: -11.81378213325238,
        },
        {
          lng: -76.90783666224218,
          lat: -11.79926250417326,
        },
        {
          lng: -76.90652157992993,
          lat: -11.79658933174004,
        },
        {
          lng: -76.90358529991938,
          lat: -11.79449480364756,
        },
        {
          lng: -76.89799501613957,
          lat: -11.79339308939317,
        },
        {
          lng: -76.88452673491112,
          lat: -11.79578564220504,
        },
        {
          lng: -76.88138873291143,
          lat: -11.79428818851618,
        },
        {
          lng: -76.87733696307104,
          lat: -11.79468612055055,
        },
        {
          lng: -76.87243298803642,
          lat: -11.79629238211732,
        },
        {
          lng: -76.86222259267927,
          lat: -11.79854378494871,
        },
        {
          lng: -76.85422806224804,
          lat: -11.79934830178815,
        },
        {
          lng: -76.85071245873972,
          lat: -11.79789243272242,
        },
        {
          lng: -76.8452470995823,
          lat: -11.79002382431246,
        },
        {
          lng: -76.84343718332126,
          lat: -11.78537939109258,
        },
        {
          lng: -76.83904809887113,
          lat: -11.7828026452588,
        },
        {
          lng: -76.83430424938038,
          lat: -11.77880861146446,
        },
        {
          lng: -76.82534515419155,
          lat: -11.77726814093744,
        },
        {
          lng: -76.82141785503458,
          lat: -11.77428429953122,
        },
        {
          lng: -76.81791973114166,
          lat: -11.76941537591624,
        },
        {
          lng: -76.8152179237164,
          lat: -11.76825323496045,
        },
        {
          lng: -76.81328442781636,
          lat: -11.76442217614797,
        },
        {
          lng: -76.80438172015027,
          lat: -11.75566928702795,
        },
        {
          lng: -76.80622301819773,
          lat: -11.75257156167513,
        },
        {
          lng: -76.80979917945344,
          lat: -11.7517426405343,
        },
        {
          lng: -76.8123048139401,
          lat: -11.74981268352457,
        },
        {
          lng: -76.82168973999524,
          lat: -11.74733067564275,
        },
        {
          lng: -76.82736920141929,
          lat: -11.74723996471224,
        },
        {
          lng: -76.83303536328454,
          lat: -11.74444478818012,
        },
        {
          lng: -76.83851927090666,
          lat: -11.74702984305427,
        },
        {
          lng: -76.84808195966951,
          lat: -11.74728869339361,
        },
        {
          lng: -76.8535052746098,
          lat: -11.74903260968841,
        },
        {
          lng: -76.85820731658738,
          lat: -11.74820309437387,
        },
        {
          lng: -76.8606550903035,
          lat: -11.74845792979209,
        },
        {
          lng: -76.8661334019924,
          lat: -11.74818649709963,
        },
        {
          lng: -76.86835982130351,
          lat: -11.74572157683381,
        },
        {
          lng: -76.8708186922098,
          lat: -11.74420202773482,
        },
        {
          lng: -76.87460475748541,
          lat: -11.74428915004723,
        },
        {
          lng: -76.87659789396274,
          lat: -11.74306065980357,
        },
        {
          lng: -76.87715678273534,
          lat: -11.7385124615894,
        },
        {
          lng: -76.8790667082228,
          lat: -11.73688347624845,
        },
        {
          lng: -76.87966040667047,
          lat: -11.734929878361,
        },
        {
          lng: -76.8815797936346,
          lat: -11.73418510638712,
        },
        {
          lng: -76.88732452437961,
          lat: -11.73558158959376,
        },
        {
          lng: -76.89295096186204,
          lat: -11.73092077606275,
        },
        {
          lng: -76.89644551896241,
          lat: -11.72956801421667,
        },
        {
          lng: -76.90111701228248,
          lat: -11.72915400670331,
        },
        {
          lng: -76.90585137263818,
          lat: -11.72996476784848,
        },
        {
          lng: -76.91462454073962,
          lat: -11.73235161884949,
        },
        {
          lng: -76.91528213138456,
          lat: -11.73589702549643,
        },
        {
          lng: -76.91408544846004,
          lat: -11.74244031658184,
        },
        {
          lng: -76.91500845842371,
          lat: -11.74471909474506,
        },
        {
          lng: -76.91852934222828,
          lat: -11.74669587101756,
        },
        {
          lng: -76.9194353123988,
          lat: -11.74930729738105,
        },
        {
          lng: -76.92246088781977,
          lat: -11.75128118359267,
        },
        {
          lng: -76.93076302433397,
          lat: -11.75403184338193,
        },
        {
          lng: -77.0262739943673,
          lat: -11.68684868309595,
        },
        {
          lng: -77.02462458396606,
          lat: -11.69286038288511,
        },
        {
          lng: -76.95142478549656,
          lat: -11.74521989785759,
        },
        {
          lng: -76.95377803052072,
          lat: -11.74185836304038,
        },
        {
          lng: -76.95504114454845,
          lat: -11.73628443537649,
        },
        {
          lng: -76.9576373391365,
          lat: -11.73604869192633,
        },
        {
          lng: -76.96049689237381,
          lat: -11.73446300943445,
        },
        {
          lng: -76.96134385754623,
          lat: -11.72998801365656,
        },
        {
          lng: -76.9664772925892,
          lat: -11.72668833453931,
        },
        {
          lng: -76.97044050158338,
          lat: -11.72519308014338,
        },
        {
          lng: -76.9736905483646,
          lat: -11.72506869431589,
        },
        {
          lng: -76.9791873613763,
          lat: -11.72663239309832,
        },
        {
          lng: -76.98030700927163,
          lat: -11.72537127954175,
        },
        {
          lng: -76.9799240109513,
          lat: -11.72057855134149,
        },
        {
          lng: -76.97656586498611,
          lat: -11.71751237234856,
        },
        {
          lng: -76.97624826325907,
          lat: -11.71488736874314,
        },
        {
          lng: -76.97515456916105,
          lat: -11.71032668779852,
        },
        {
          lng: -76.97567620915201,
          lat: -11.70568443325048,
        },
        {
          lng: -76.97706477183925,
          lat: -11.70067274206699,
        },
        {
          lng: -76.9796467513398,
          lat: -11.69729136032516,
        },
        {
          lng: -76.97927681605766,
          lat: -11.69503790194331,
        },
        {
          lng: -76.97738675961895,
          lat: -11.69354096358697,
        },
        {
          lng: -76.97486847534704,
          lat: -11.69029981888243,
        },
        {
          lng: -76.97431627298704,
          lat: -11.68659447727149,
        },
        {
          lng: -76.97588302687006,
          lat: -11.68539195921242,
        },
        {
          lng: -76.98376064438922,
          lat: -11.68564132169246,
        },
        {
          lng: -76.98977799055673,
          lat: -11.68417231478529,
        },
        {
          lng: -76.99521311607838,
          lat: -11.68684855096077,
        },
        {
          lng: -77.0033510219679,
          lat: -11.68571441493416,
        },
        {
          lng: -77.0075597696823,
          lat: -11.68490343282445,
        },
        {
          lng: -77.01314188568395,
          lat: -11.6805773707576,
        },
        {
          lng: -77.01553842114639,
          lat: -11.67996519162821,
        },
        {
          lng: -77.01989987203687,
          lat: -11.68010111662768,
        },
        {
          lng: -77.0245575870126,
          lat: -11.68080728847156,
        },
        {
          lng: -76.93240472885911,
          lat: -11.75557234517325,
        },
        {
          lng: -76.93484101496236,
          lat: -11.75491476973342,
        },
        {
          lng: -76.93734020865723,
          lat: -11.7517636665971,
        },
        {
          lng: -76.94004658972999,
          lat: -11.75038892657211,
        },
        {
          lng: -76.94550549359565,
          lat: -11.75046071348544,
        },
        {
          lng: -76.94847544769566,
          lat: -11.74723901925526,
        },
      ],
    },
    {
      ubigeo: '150103',
      name: 'HUAYCAN',
      poligonos: [
        {
          lng: -76.82722544079624,
          lat: -12.01415144105395,
        },
        {
          lng: -76.82790703301424,
          lat: -12.01726428616491,
        },
        {
          lng: -76.82842655683442,
          lat: -12.02541089724761,
        },
        {
          lng: -76.82841205827226,
          lat: -12.03005878460156,
        },
        {
          lng: -76.82969189723491,
          lat: -12.04033131724513,
        },
        {
          lng: -76.82624060308977,
          lat: -12.0435910569807,
        },
        {
          lng: -76.81147324755123,
          lat: -12.03735927898758,
        },
        {
          lng: -76.80189601435322,
          lat: -12.02749721256267,
        },
        {
          lng: -76.7930786421273,
          lat: -12.01337347742982,
        },
        {
          lng: -76.79446308599267,
          lat: -12.00662489710221,
        },
        {
          lng: -76.81105159689679,
          lat: -12.0046561850391,
        },
        {
          lng: -76.82406224342783,
          lat: -12.00437836463804,
        },
        {
          lng: -76.8292780190647,
          lat: -12.01035421206956,
        },
      ],
    },
    {
      ubigeo: '150106',
      name: 'CARABAYLLO',
      poligonos: [
        {
          lng: -77.02627399436739,
          lat: -11.68684868309595,
        },
        {
          lng: -77.02462458396606,
          lat: -11.69286038288511,
        },
        {
          lng: -77.02814653174657,
          lat: -11.70327233459019,
        },
        {
          lng: -77.03291012421137,
          lat: -11.70895874226238,
        },
        {
          lng: -77.03622170550295,
          lat: -11.71066840796155,
        },
        {
          lng: -77.04149298002608,
          lat: -11.71294631331127,
        },
        {
          lng: -77.04306753726829,
          lat: -11.71661406117544,
        },
        {
          lng: -77.03860312900787,
          lat: -11.72318690251138,
        },
        {
          lng: -77.0364166667892,
          lat: -11.73096960708352,
        },
        {
          lng: -77.03389272653125,
          lat: -11.73465150804972,
        },
        {
          lng: -77.03139052013967,
          lat: -11.73956298055296,
        },
        {
          lng: -77.03909250712512,
          lat: -11.75265562871457,
        },
        {
          lng: -77.04318419958362,
          lat: -11.75435485584795,
        },
        {
          lng: -77.04471376643147,
          lat: -11.75794811222856,
        },
        {
          lng: -77.05007617628502,
          lat: -11.76121686386898,
        },
        {
          lng: -77.05379835888462,
          lat: -11.76554148988128,
        },
        {
          lng: -77.05502325384727,
          lat: -11.77026752753975,
        },
        {
          lng: -77.0539919019262,
          lat: -11.77387784367084,
        },
        {
          lng: -77.05382413183843,
          lat: -11.77931801559115,
        },
        {
          lng: -77.05714127906353,
          lat: -11.78576588051055,
        },
        {
          lng: -77.06119384171892,
          lat: -11.78817175848958,
        },
        {
          lng: -77.06459296057007,
          lat: -11.78896515689567,
        },
        {
          lng: -77.06858936509522,
          lat: -11.79028653461648,
        },
        {
          lng: -77.07327308372814,
          lat: -11.79219826679818,
        },
        {
          lng: -77.07421536063252,
          lat: -11.79615732363777,
        },
        {
          lng: -77.07987601816666,
          lat: -11.79894351346486,
        },
        {
          lng: -77.0825274425327,
          lat: -11.80099261498088,
        },
        {
          lng: -77.09259576665336,
          lat: -11.80350425166394,
        },
        {
          lng: -77.09355293219582,
          lat: -11.80773697764818,
        },
        {
          lng: -77.09079708263323,
          lat: -11.81382064732527,
        },
        {
          lng: -77.08293352397268,
          lat: -11.84080210355708,
        },
        {
          lng: -77.076122086138,
          lat: -11.84677179473534,
        },
        {
          lng: -77.06420740713509,
          lat: -11.85184957810769,
        },
        {
          lng: -77.05947584101769,
          lat: -11.8582544465528,
        },
        {
          lng: -77.05792390767452,
          lat: -11.86538332063209,
        },
        {
          lng: -77.0593139057414,
          lat: -11.86874691304567,
        },
        {
          lng: -77.0552190148858,
          lat: -11.87455069250161,
        },
        {
          lng: -77.05592581996802,
          lat: -11.88558710747746,
        },
        {
          lng: -77.05422723740627,
          lat: -11.88960776950433,
        },
        {
          lng: -77.05084245433477,
          lat: -11.88715519350449,
        },
        {
          lng: -77.04676567940962,
          lat: -11.89327051241696,
        },
        {
          lng: -77.04808736258538,
          lat: -11.8960531674045,
        },
        {
          lng: -77.0460127254302,
          lat: -11.8976399228978,
        },
        {
          lng: -77.04344999935049,
          lat: -11.89715902527125,
        },
        {
          lng: -77.04232962899401,
          lat: -11.89456600371008,
        },
        {
          lng: -77.03958244119475,
          lat: -11.89687248078409,
        },
        {
          lng: -77.03382862369486,
          lat: -11.90690661092159,
        },
        {
          lng: -77.03063547319479,
          lat: -11.90999258072218,
        },
        {
          lng: -77.02310824249022,
          lat: -11.90835566249994,
        },
        {
          lng: -77.01990003545598,
          lat: -11.90553964109828,
        },
        {
          lng: -77.01393425896632,
          lat: -11.90305090518299,
        },
        {
          lng: -77.01160041264079,
          lat: -11.90403555878673,
        },
        {
          lng: -77.00585255337758,
          lat: -11.9040135607614,
        },
        {
          lng: -76.99993209491409,
          lat: -11.89974473447789,
        },
        {
          lng: -76.99610749473567,
          lat: -11.89910320868902,
        },
        {
          lng: -76.99282313679048,
          lat: -11.90074284267577,
        },
        {
          lng: -76.99019493269567,
          lat: -11.90029536553927,
        },
        {
          lng: -76.98731506111378,
          lat: -11.89636453718302,
        },
        {
          lng: -76.9831743929344,
          lat: -11.89383124436707,
        },
        {
          lng: -76.97720658732445,
          lat: -11.89162464336064,
        },
        {
          lng: -76.97429755229899,
          lat: -11.88941151205225,
        },
        {
          lng: -76.97066799606839,
          lat: -11.8849690938319,
        },
        {
          lng: -76.96608699620141,
          lat: -11.87796410646499,
        },
        {
          lng: -76.96332865825981,
          lat: -11.87434092038073,
        },
        {
          lng: -76.96085472968265,
          lat: -11.87197347994931,
        },
        {
          lng: -76.95652657791207,
          lat: -11.87025850888735,
        },
        {
          lng: -76.95480664272478,
          lat: -11.86766774125472,
        },
        {
          lng: -76.95237591887583,
          lat: -11.86550044691588,
        },
        {
          lng: -76.94730869027315,
          lat: -11.86259537440242,
        },
        {
          lng: -76.94194277352864,
          lat: -11.86091640576953,
        },
        {
          lng: -76.94092214357987,
          lat: -11.85707122269126,
        },
        {
          lng: -76.93724960146561,
          lat: -11.85131766697982,
        },
        {
          lng: -76.93452430233722,
          lat: -11.84576178896484,
        },
        {
          lng: -76.93401126856763,
          lat: -11.83717556077536,
        },
        {
          lng: -76.935545739863,
          lat: -11.8338909830242,
        },
        {
          lng: -76.93426825971703,
          lat: -11.8327232416948,
        },
        {
          lng: -76.93004185129739,
          lat: -11.8337219153786,
        },
        {
          lng: -76.92585986053707,
          lat: -11.83283344413388,
        },
        {
          lng: -76.92142857419805,
          lat: -11.83148728112488,
        },
        {
          lng: -76.91602728116125,
          lat: -11.83181034138924,
        },
        {
          lng: -76.91263955947423,
          lat: -11.8288254891172,
        },
        {
          lng: -76.90628647599117,
          lat: -11.82619032028452,
        },
        {
          lng: -76.9032772213492,
          lat: -11.82274045046477,
        },
        {
          lng: -76.90657221285296,
          lat: -11.81378213325238,
        },
        {
          lng: -76.90783666224218,
          lat: -11.79926250417326,
        },
        {
          lng: -76.90652157992993,
          lat: -11.79658933174004,
        },
        {
          lng: -76.90358529991938,
          lat: -11.79449480364756,
        },
        {
          lng: -76.89799501613957,
          lat: -11.79339308939317,
        },
        {
          lng: -76.88452673491112,
          lat: -11.79578564220504,
        },
        {
          lng: -76.88138873291143,
          lat: -11.79428818851618,
        },
        {
          lng: -76.87733696307104,
          lat: -11.79468612055055,
        },
        {
          lng: -76.87243298803642,
          lat: -11.79629238211732,
        },
        {
          lng: -76.86222259267927,
          lat: -11.79854378494871,
        },
        {
          lng: -76.85422806224804,
          lat: -11.79934830178815,
        },
        {
          lng: -76.85071245873972,
          lat: -11.79789243272242,
        },
        {
          lng: -76.8452470995823,
          lat: -11.79002382431246,
        },
        {
          lng: -76.84343718332126,
          lat: -11.78537939109258,
        },
        {
          lng: -76.83904809887113,
          lat: -11.7828026452588,
        },
        {
          lng: -76.83430424938038,
          lat: -11.77880861146446,
        },
        {
          lng: -76.82534515419155,
          lat: -11.77726814093744,
        },
        {
          lng: -76.82141785503458,
          lat: -11.77428429953122,
        },
        {
          lng: -76.81791973114166,
          lat: -11.76941537591624,
        },
        {
          lng: -76.8152179237164,
          lat: -11.76825323496045,
        },
        {
          lng: -76.81328442781636,
          lat: -11.76442217614797,
        },
        {
          lng: -76.80438172015027,
          lat: -11.75566928702795,
        },
        {
          lng: -76.80622301819773,
          lat: -11.75257156167513,
        },
        {
          lng: -76.80979917945344,
          lat: -11.7517426405343,
        },
        {
          lng: -76.8123048139401,
          lat: -11.74981268352457,
        },
        {
          lng: -76.82168973999524,
          lat: -11.74733067564275,
        },
        {
          lng: -76.82736920141929,
          lat: -11.74723996471224,
        },
        {
          lng: -76.83303536328454,
          lat: -11.74444478818012,
        },
        {
          lng: -76.83851927090666,
          lat: -11.74702984305427,
        },
        {
          lng: -76.84808195966951,
          lat: -11.74728869339361,
        },
        {
          lng: -76.8535052746098,
          lat: -11.74903260968841,
        },
        {
          lng: -76.85820731658738,
          lat: -11.74820309437387,
        },
        {
          lng: -76.8606550903035,
          lat: -11.74845792979209,
        },
        {
          lng: -76.8661334019924,
          lat: -11.74818649709963,
        },
        {
          lng: -76.86835982130351,
          lat: -11.74572157683381,
        },
        {
          lng: -76.8708186922098,
          lat: -11.74420202773482,
        },
        {
          lng: -76.87460475748541,
          lat: -11.74428915004723,
        },
        {
          lng: -76.87659789396274,
          lat: -11.74306065980357,
        },
        {
          lng: -76.87715678273534,
          lat: -11.7385124615894,
        },
        {
          lng: -76.8790667082228,
          lat: -11.73688347624845,
        },
        {
          lng: -76.87966040667047,
          lat: -11.734929878361,
        },
        {
          lng: -76.8815797936346,
          lat: -11.73418510638712,
        },
        {
          lng: -76.88732452437961,
          lat: -11.73558158959376,
        },
        {
          lng: -76.89295096186204,
          lat: -11.73092077606275,
        },
        {
          lng: -76.89644551896241,
          lat: -11.72956801421667,
        },
        {
          lng: -76.90111701228248,
          lat: -11.72915400670331,
        },
        {
          lng: -76.90585137263818,
          lat: -11.72996476784848,
        },
        {
          lng: -76.91462454073962,
          lat: -11.73235161884949,
        },
        {
          lng: -76.91528213138456,
          lat: -11.73589702549643,
        },
        {
          lng: -76.91408544846004,
          lat: -11.74244031658184,
        },
        {
          lng: -76.91500845842371,
          lat: -11.74471909474506,
        },
        {
          lng: -76.91852934222828,
          lat: -11.74669587101756,
        },
        {
          lng: -76.9194353123988,
          lat: -11.74930729738105,
        },
        {
          lng: -76.92246088781977,
          lat: -11.75128118359267,
        },
        {
          lng: -76.93076302433397,
          lat: -11.75403184338193,
        },
        {
          lng: -76.93240472885911,
          lat: -11.75557234517325,
        },
        {
          lng: -76.93484101496236,
          lat: -11.75491476973342,
        },
        {
          lng: -76.93734020865723,
          lat: -11.7517636665971,
        },
        {
          lng: -76.94004658972999,
          lat: -11.75038892657211,
        },
        {
          lng: -76.94550549359565,
          lat: -11.75046071348544,
        },
        {
          lng: -76.94847544769566,
          lat: -11.74723901925526,
        },
        {
          lng: -76.95142478549656,
          lat: -11.74521989785759,
        },
        {
          lng: -76.95377803052072,
          lat: -11.74185836304038,
        },
        {
          lng: -76.95504114454845,
          lat: -11.73628443537649,
        },
        {
          lng: -76.9576373391365,
          lat: -11.73604869192633,
        },
        {
          lng: -76.96049689237381,
          lat: -11.73446300943445,
        },
        {
          lng: -76.96134385754623,
          lat: -11.72998801365656,
        },
        {
          lng: -76.9664772925892,
          lat: -11.72668833453931,
        },
        {
          lng: -76.97044050158338,
          lat: -11.72519308014338,
        },
        {
          lng: -76.9736905483646,
          lat: -11.72506869431589,
        },
        {
          lng: -76.9791873613763,
          lat: -11.72663239309832,
        },
        {
          lng: -76.98030700927163,
          lat: -11.72537127954175,
        },
        {
          lng: -76.9799240109513,
          lat: -11.72057855134149,
        },
        {
          lng: -76.97656586498611,
          lat: -11.71751237234856,
        },
        {
          lng: -76.97624826325907,
          lat: -11.71488736874314,
        },
        {
          lng: -76.97515456916105,
          lat: -11.71032668779852,
        },
        {
          lng: -76.97567620915201,
          lat: -11.70568443325048,
        },
        {
          lng: -76.97706477183925,
          lat: -11.70067274206699,
        },
        {
          lng: -76.9796467513398,
          lat: -11.69729136032516,
        },
        {
          lng: -76.97927681605766,
          lat: -11.69503790194331,
        },
        {
          lng: -76.97738675961895,
          lat: -11.69354096358697,
        },
        {
          lng: -76.97486847534704,
          lat: -11.69029981888243,
        },
        {
          lng: -76.97431627298704,
          lat: -11.68659447727149,
        },
        {
          lng: -76.97588302687006,
          lat: -11.68539195921242,
        },
        {
          lng: -76.98376064438922,
          lat: -11.68564132169246,
        },
        {
          lng: -76.98977799055673,
          lat: -11.68417231478529,
        },
        {
          lng: -76.99521311607838,
          lat: -11.68684855096077,
        },
        {
          lng: -77.0033510219679,
          lat: -11.68571441493416,
        },
        {
          lng: -77.0075597696823,
          lat: -11.68490343282445,
        },
        {
          lng: -77.09101463961547,
          lat: -11.81861386043686,
        },
        {
          lng: -77.09018922418798,
          lat: -11.82372277033055,
        },
        {
          lng: -77.08809964402911,
          lat: -11.82499131123629,
        },
        {
          lng: -77.08863769884975,
          lat: -11.83015769199457,
        },
        {
          lng: -77.08869907414878,
          lat: -11.8341265049602,
        },
        {
          lng: -77.08697519952435,
          lat: -11.83842543786111,
        },
        {
          lng: -77.01314188568395,
          lat: -11.6805773707576,
        },
        {
          lng: -77.01553842114639,
          lat: -11.67996519162821,
        },
        {
          lng: -77.01989987203687,
          lat: -11.68010111662768,
        },
        {
          lng: -77.0245575870126,
          lat: -11.68080728847156,
        },
      ],
    },
    {
      ubigeo: '150108',
      name: 'SAN GENARO',
      poligonos: [
        {
          lng: -77.02192435930212,
          lat: -12.19101906875203,
        },
        {
          lng: -77.02272149853567,
          lat: -12.19230934346046,
        },
        {
          lng: -77.0264537738147,
          lat: -12.19406457365688,
        },
        {
          lng: -77.02620912946203,
          lat: -12.19447389384489,
        },
        {
          lng: -77.02422145278004,
          lat: -12.19857076718623,
        },
        {
          lng: -77.02361183917021,
          lat: -12.19879188341794,
        },
        {
          lng: -77.0222191199704,
          lat: -12.19974235912239,
        },
        {
          lng: -77.02183181456286,
          lat: -12.19976933764589,
        },
        {
          lng: -77.02168764317958,
          lat: -12.19878620131413,
        },
        {
          lng: -77.02103877597641,
          lat: -12.19863894628434,
        },
        {
          lng: -77.02012554415421,
          lat: -12.19823951856657,
        },
        {
          lng: -77.01955287600364,
          lat: -12.19731565785342,
        },
        {
          lng: -77.01987322851826,
          lat: -12.19663263318621,
        },
        {
          lng: -77.01933184348024,
          lat: -12.19622455738592,
        },
        {
          lng: -77.01837351883644,
          lat: -12.19499719635359,
        },
        {
          lng: -77.01845297513246,
          lat: -12.19399980568008,
        },
        {
          lng: -77.01789036516067,
          lat: -12.19314902671704,
        },
        {
          lng: -77.01961452944845,
          lat: -12.1923123302954,
        },
      ],
    },
    {
      ubigeo: '150108',
      name: 'MATEO PUMACAHUA',
      poligonos: [
        {
          lng: -76.97937767636738,
          lat: -12.19070949267681,
        },
        {
          lng: -76.9843889755046,
          lat: -12.18943234506508,
        },
        {
          lng: -76.9850147213662,
          lat: -12.19037251706076,
        },
        {
          lng: -76.97909045230246,
          lat: -12.19609443571553,
        },
        {
          lng: -76.97733913716243,
          lat: -12.19417761743495,
        },
        {
          lng: -76.97759434596479,
          lat: -12.19399045909263,
        },
        {
          lng: -76.97842789232803,
          lat: -12.19280090552217,
        },
        {
          lng: -76.979163982356,
          lat: -12.19127538936513,
        },
        {
          lng: -76.97921652557314,
          lat: -12.19109333249841,
        },
        {
          lng: -76.97944070651376,
          lat: -12.19035113314999,
        },
        {
          lng: -76.97943824376759,
          lat: -12.18989076411734,
        },
        {
          lng: -76.97961105156499,
          lat: -12.1872771570892,
        },
        {
          lng: -76.98041069112149,
          lat: -12.18764193589049,
        },
        {
          lng: -76.980608442441,
          lat: -12.18758467965782,
        },
        {
          lng: -76.9834986822489,
          lat: -12.18831720427111,
        },
      ],
    },
    {
      ubigeo: '150108',
      name: 'MARCAVILCA',
      poligonos: [
        {
          lng: -77.02497131255113,
          lat: -12.17457260184848,
        },
        {
          lng: -77.0252387147948,
          lat: -12.17440038508156,
        },
        {
          lng: -77.02583670205138,
          lat: -12.17424218194237,
        },
        {
          lng: -77.02643938685894,
          lat: -12.17435569447099,
        },
        {
          lng: -77.02656843177954,
          lat: -12.17441333937299,
        },
        {
          lng: -77.02670807731315,
          lat: -12.17453501730133,
        },
        {
          lng: -77.02681606264649,
          lat: -12.1745672195795,
        },
        {
          lng: -77.02692319828826,
          lat: -12.17470712806086,
        },
        {
          lng: -77.02705747849532,
          lat: -12.17482912222499,
        },
        {
          lng: -77.02742987341574,
          lat: -12.17503854541087,
        },
        {
          lng: -77.02755505243496,
          lat: -12.17507196490451,
        },
        {
          lng: -77.02764051502159,
          lat: -12.17513729728416,
        },
        {
          lng: -77.02768073357781,
          lat: -12.17530497831535,
        },
        {
          lng: -77.02762342547888,
          lat: -12.17552287385992,
        },
        {
          lng: -77.02750992208361,
          lat: -12.17573001853853,
        },
        {
          lng: -77.02734771342666,
          lat: -12.17590191835204,
        },
        {
          lng: -77.02698326764119,
          lat: -12.17646167172498,
        },
        {
          lng: -77.0266364795623,
          lat: -12.17691103581752,
        },
        {
          lng: -77.0264249108165,
          lat: -12.17716333901905,
        },
        {
          lng: -77.02620332712704,
          lat: -12.17736353322222,
        },
        {
          lng: -77.02609507872145,
          lat: -12.17750433283693,
        },
        {
          lng: -77.02587627700629,
          lat: -12.17751379857468,
        },
        {
          lng: -77.02551117174033,
          lat: -12.17719163458889,
        },
        {
          lng: -77.02532750871914,
          lat: -12.17711836472632,
        },
        {
          lng: -77.02517802162937,
          lat: -12.17712945516238,
        },
        {
          lng: -77.02500597340334,
          lat: -12.17709756064247,
        },
        {
          lng: -77.0249163552862,
          lat: -12.17700085700044,
        },
        {
          lng: -77.02474483607165,
          lat: -12.17695238828851,
        },
        {
          lng: -77.02464473153734,
          lat: -12.17654621106874,
        },
        {
          lng: -77.02455505993706,
          lat: -12.17647002985418,
        },
        {
          lng: -77.02399155411274,
          lat: -12.1765766810376,
        },
        {
          lng: -77.0232517815075,
          lat: -12.17600636760065,
        },
        {
          lng: -77.02303095702096,
          lat: -12.17567628411689,
        },
        {
          lng: -77.02323917461891,
          lat: -12.17529824901887,
        },
        {
          lng: -77.02352731339471,
          lat: -12.17504476151616,
        },
        {
          lng: -77.02452162411521,
          lat: -12.17464017765747,
        },
      ],
    },
    {
      ubigeo: '150108',
      name: 'A.H. SAN JOSE II',
      poligonos: [
        {
          lng: -77.02286796801874,
          lat: -12.18822974957391,
        },
        {
          lng: -77.02287957745472,
          lat: -12.18844180930466,
        },
        {
          lng: -77.02318770353537,
          lat: -12.18850183178766,
        },
        {
          lng: -77.02332617736897,
          lat: -12.18862761303801,
        },
        {
          lng: -77.02403640127393,
          lat: -12.18935429857917,
        },
        {
          lng: -77.0244996823381,
          lat: -12.18970577325354,
        },
        {
          lng: -77.02443142947233,
          lat: -12.18978230185996,
        },
        {
          lng: -77.02427261647975,
          lat: -12.18983399313657,
        },
        {
          lng: -77.0241496981503,
          lat: -12.1899912667714,
        },
        {
          lng: -77.02413625899038,
          lat: -12.19017031892615,
        },
        {
          lng: -77.02418230096839,
          lat: -12.19035531275777,
        },
        {
          lng: -77.02414940023894,
          lat: -12.19043383193311,
        },
        {
          lng: -77.02417238424688,
          lat: -12.19052625545011,
        },
        {
          lng: -77.02413847357347,
          lat: -12.19061556538211,
        },
        {
          lng: -77.0240187462675,
          lat: -12.1906823938783,
        },
        {
          lng: -77.02357818003888,
          lat: -12.18992191675256,
        },
        {
          lng: -77.02343179739974,
          lat: -12.18963041893343,
        },
        {
          lng: -77.0231302460198,
          lat: -12.1892606918179,
        },
        {
          lng: -77.02294591296773,
          lat: -12.1894312460859,
        },
        {
          lng: -77.02293267818261,
          lat: -12.18958852849492,
        },
        {
          lng: -77.02267150175555,
          lat: -12.18971847804639,
        },
        {
          lng: -77.02221475566314,
          lat: -12.18994472739582,
        },
        {
          lng: -77.02169567407977,
          lat: -12.19012317148516,
        },
        {
          lng: -77.02162919311161,
          lat: -12.18988226282731,
        },
        {
          lng: -77.02155158519344,
          lat: -12.18959423014244,
        },
        {
          lng: -77.02084549149858,
          lat: -12.18943817151814,
        },
        {
          lng: -77.02085742705161,
          lat: -12.18925400409002,
        },
        {
          lng: -77.0210073546102,
          lat: -12.18865873219023,
        },
        {
          lng: -77.02114416121242,
          lat: -12.18871301310386,
        },
        {
          lng: -77.0212114080988,
          lat: -12.18871301674541,
        },
        {
          lng: -77.02142822605148,
          lat: -12.18878887617752,
        },
        {
          lng: -77.02169263250498,
          lat: -12.18894274518524,
        },
        {
          lng: -77.02190560437774,
          lat: -12.18883137318164,
        },
        {
          lng: -77.0221535083033,
          lat: -12.1884466735338,
        },
        {
          lng: -77.02218784120153,
          lat: -12.18820468814355,
        },
      ],
    },
    {
      ubigeo: '150108',
      name: 'A.H. SAN JOSE I',
      poligonos: [
        {
          lng: -77.02605896837494,
          lat: -12.19049435509921,
        },
        {
          lng: -77.02648961355004,
          lat: -12.19096933917303,
        },
        {
          lng: -77.02694299700885,
          lat: -12.19158465880271,
        },
        {
          lng: -77.02717723769432,
          lat: -12.19180848523715,
        },
        {
          lng: -77.0275979039916,
          lat: -12.19212061765707,
        },
        {
          lng: -77.02750875483932,
          lat: -12.19221414490449,
        },
        {
          lng: -77.02750297594515,
          lat: -12.19232118436671,
        },
        {
          lng: -77.02738387084986,
          lat: -12.19249581442913,
        },
        {
          lng: -77.027318629607,
          lat: -12.19253084321757,
        },
        {
          lng: -77.02607447838565,
          lat: -12.1914774316448,
        },
        {
          lng: -77.02565164068922,
          lat: -12.19121979710238,
        },
        {
          lng: -77.02532479117468,
          lat: -12.19106828734459,
        },
        {
          lng: -77.02523636266736,
          lat: -12.1909803778891,
        },
        {
          lng: -77.02537396640084,
          lat: -12.19073483063205,
        },
        {
          lng: -77.02547386942969,
          lat: -12.19066369102691,
        },
        {
          lng: -77.02549454075097,
          lat: -12.19051403835438,
        },
        {
          lng: -77.02572685079816,
          lat: -12.19032098765308,
        },
        {
          lng: -77.02583761825636,
          lat: -12.19018674256843,
        },
      ],
    },
    {
      ubigeo: '150108',
      name: 'COLINAS DE VILLA',
      poligonos: [
        {
          lng: -77.02878764593451,
          lat: -12.19620300218837,
        },
        {
          lng: -77.02883923136308,
          lat: -12.19690257216356,
        },
        {
          lng: -77.02927272000534,
          lat: -12.1976930564895,
        },
        {
          lng: -77.02932421308944,
          lat: -12.19807185343462,
        },
        {
          lng: -77.02923151075288,
          lat: -12.19847843299154,
        },
        {
          lng: -77.02780824205246,
          lat: -12.19857887373579,
        },
        {
          lng: -77.02628052369379,
          lat: -12.19844355768456,
        },
        {
          lng: -77.02423516901908,
          lat: -12.19859770153704,
        },
        {
          lng: -77.02642035859489,
          lat: -12.19410042827552,
        },
        {
          lng: -77.02869627416807,
          lat: -12.19513481002921,
        },
      ],
    },
    {
      ubigeo: '150108',
      name: 'A.H. PACIFICO DE VILLA',
      poligonos: [
        {
          lng: -77.03194953861373,
          lat: -12.20058348320406,
        },
        {
          lng: -77.03274769749234,
          lat: -12.20087317140752,
        },
        {
          lng: -77.03303914698957,
          lat: -12.20085000850743,
        },
        {
          lng: -77.03321811179809,
          lat: -12.2016739659642,
        },
        {
          lng: -77.03196869249477,
          lat: -12.20282738293267,
        },
        {
          lng: -77.03168395231414,
          lat: -12.20253265086015,
        },
        {
          lng: -77.03157728765402,
          lat: -12.20267382413987,
        },
        {
          lng: -77.03151563854941,
          lat: -12.20291393240931,
        },
        {
          lng: -77.03164699140366,
          lat: -12.20301485966316,
        },
        {
          lng: -77.03171593904196,
          lat: -12.20317703715126,
        },
        {
          lng: -77.03165378625646,
          lat: -12.20342967349667,
        },
        {
          lng: -77.03152283955393,
          lat: -12.20363927413042,
        },
        {
          lng: -77.03124786734188,
          lat: -12.20381359638822,
        },
        {
          lng: -77.03111415172737,
          lat: -12.20352949822879,
        },
        {
          lng: -77.0309956861211,
          lat: -12.20341819200373,
        },
        {
          lng: -77.03071486572988,
          lat: -12.20345098006312,
        },
        {
          lng: -77.03042284450166,
          lat: -12.20368691781362,
        },
        {
          lng: -77.02989365524827,
          lat: -12.20427818551049,
        },
        {
          lng: -77.0296669832918,
          lat: -12.20418475901266,
        },
        {
          lng: -77.02952327515705,
          lat: -12.20394039696983,
        },
        {
          lng: -77.02983938118547,
          lat: -12.20353312696674,
        },
        {
          lng: -77.02988921750524,
          lat: -12.20341152843884,
        },
        {
          lng: -77.03001474677804,
          lat: -12.20313169425219,
        },
        {
          lng: -77.03004986927695,
          lat: -12.20292574374796,
        },
        {
          lng: -77.03002468215206,
          lat: -12.20269054824395,
        },
        {
          lng: -77.02977853798582,
          lat: -12.20231274005159,
        },
        {
          lng: -77.02956110541736,
          lat: -12.20200338942554,
        },
        {
          lng: -77.02939287866784,
          lat: -12.20169225247221,
        },
        {
          lng: -77.02883254799623,
          lat: -12.20112382652336,
        },
        {
          lng: -77.02765861906715,
          lat: -12.2005171197409,
        },
        {
          lng: -77.02781276967448,
          lat: -12.20009655488736,
        },
        {
          lng: -77.02807498069257,
          lat: -12.19958615206699,
        },
        {
          lng: -77.02845001056666,
          lat: -12.19923483609951,
        },
        {
          lng: -77.0287577631193,
          lat: -12.19928840639806,
        },
        {
          lng: -77.02921758637346,
          lat: -12.19944326678903,
        },
        {
          lng: -77.02959653276773,
          lat: -12.19962807296517,
        },
        {
          lng: -77.02971150349286,
          lat: -12.19976832073687,
        },
        {
          lng: -77.02978116427295,
          lat: -12.19993688874985,
        },
        {
          lng: -77.02982224068101,
          lat: -12.20020063136167,
        },
        {
          lng: -77.03042692210484,
          lat: -12.20002219842978,
        },
        {
          lng: -77.03078785936489,
          lat: -12.2002956867377,
        },
        {
          lng: -77.03133992806923,
          lat: -12.20051371628459,
        },
        {
          lng: -77.0315590010166,
          lat: -12.20025590469973,
        },
      ],
    },
    {
      ubigeo: '150108',
      name: 'TACALA',
      poligonos: [
        {
          lng: -76.99161612510062,
          lat: -12.18539109538721,
        },
        {
          lng: -76.99210002547643,
          lat: -12.18584758199888,
        },
        {
          lng: -76.99171852993229,
          lat: -12.18632568260008,
        },
        {
          lng: -76.99177419818842,
          lat: -12.1876576309522,
        },
        {
          lng: -76.98873552296553,
          lat: -12.18783454712978,
        },
        {
          lng: -76.98859377226997,
          lat: -12.18776360117444,
        },
        {
          lng: -76.98903514092211,
          lat: -12.1870283709729,
        },
        {
          lng: -76.98940334633257,
          lat: -12.18679008561761,
        },
        {
          lng: -76.98962940541696,
          lat: -12.1863428062196,
        },
        {
          lng: -76.99076587437598,
          lat: -12.18473295101508,
        },
        {
          lng: -76.9913522391171,
          lat: -12.18386587197717,
        },
        {
          lng: -76.99147106532031,
          lat: -12.18353230824867,
        },
        {
          lng: -76.99170968126454,
          lat: -12.18340144330592,
        },
        {
          lng: -76.99209798119549,
          lat: -12.18399930208909,
        },
        {
          lng: -76.99219094057248,
          lat: -12.18419488325992,
        },
        {
          lng: -76.9920870879877,
          lat: -12.18435232570299,
        },
        {
          lng: -76.99235202625542,
          lat: -12.18455025395225,
        },
        {
          lng: -76.99239738414559,
          lat: -12.18466111915419,
        },
        {
          lng: -76.99269584921802,
          lat: -12.1848632386561,
        },
        {
          lng: -76.99268899190467,
          lat: -12.18500167011528,
        },
        {
          lng: -76.99243905921394,
          lat: -12.18523230240489,
        },
        {
          lng: -76.99207863442689,
          lat: -12.18488620026167,
        },
      ],
    },
    {
      ubigeo: '150108',
      name: 'VISTA ALEGRE',
      poligonos: [
        {
          lng: -76.99583839564984,
          lat: -12.18715930335439,
        },
        {
          lng: -76.99571029170247,
          lat: -12.1873080892759,
        },
        {
          lng: -76.99585941812994,
          lat: -12.18741166315601,
        },
        {
          lng: -76.99614861247936,
          lat: -12.18743033631156,
        },
        {
          lng: -76.99622489720899,
          lat: -12.18770649112222,
        },
        {
          lng: -76.99631891186083,
          lat: -12.18879804332395,
        },
        {
          lng: -76.99593322259537,
          lat: -12.18911644306586,
        },
        {
          lng: -76.99459635638037,
          lat: -12.18917918755945,
        },
        {
          lng: -76.99450679828131,
          lat: -12.18928626288962,
        },
        {
          lng: -76.99413991321578,
          lat: -12.18955693634058,
        },
        {
          lng: -76.99444001585255,
          lat: -12.18988551864823,
        },
        {
          lng: -76.99453301461459,
          lat: -12.19002733198171,
        },
        {
          lng: -76.99457259058283,
          lat: -12.19026876945503,
        },
        {
          lng: -76.9945472223893,
          lat: -12.19040680398057,
        },
        {
          lng: -76.99400368269743,
          lat: -12.19094638460878,
        },
        {
          lng: -76.99368666712706,
          lat: -12.19070017701818,
        },
        {
          lng: -76.99384454548294,
          lat: -12.1904806473459,
        },
        {
          lng: -76.9939324004495,
          lat: -12.19017722274625,
        },
        {
          lng: -76.99388281058418,
          lat: -12.18993731857941,
        },
        {
          lng: -76.99375464625905,
          lat: -12.18975144979883,
        },
        {
          lng: -76.99334558174856,
          lat: -12.18998953330856,
        },
        {
          lng: -76.99343487906897,
          lat: -12.19012851062089,
        },
        {
          lng: -76.99341639896586,
          lat: -12.19024787420755,
        },
        {
          lng: -76.99323638713125,
          lat: -12.19038490904639,
        },
        {
          lng: -76.99307870182828,
          lat: -12.19045262267363,
        },
        {
          lng: -76.99288351395629,
          lat: -12.19049701770597,
        },
        {
          lng: -76.99273395240316,
          lat: -12.19047997858929,
        },
        {
          lng: -76.9924324357422,
          lat: -12.19072422657016,
        },
        {
          lng: -76.99217223266763,
          lat: -12.19065275256163,
        },
        {
          lng: -76.99194181393743,
          lat: -12.19160552651635,
        },
        {
          lng: -76.99176926592975,
          lat: -12.191515447712,
        },
        {
          lng: -76.9912615941558,
          lat: -12.19136641086858,
        },
        {
          lng: -76.99068694484407,
          lat: -12.19115304492928,
        },
        {
          lng: -76.98968064063735,
          lat: -12.19084599336322,
        },
        {
          lng: -76.98911785569464,
          lat: -12.19060961417498,
        },
        {
          lng: -76.98919516042893,
          lat: -12.18996176433446,
        },
        {
          lng: -76.98953969401683,
          lat: -12.18941900734821,
        },
        {
          lng: -76.98991030990014,
          lat: -12.18916359757259,
        },
        {
          lng: -76.98990811347858,
          lat: -12.18900512743531,
        },
        {
          lng: -76.98997352814614,
          lat: -12.188926492749,
        },
        {
          lng: -76.98994527269201,
          lat: -12.18866405077003,
        },
        {
          lng: -76.99005632997768,
          lat: -12.18866109632732,
        },
        {
          lng: -76.99000440516326,
          lat: -12.18775084424802,
        },
        {
          lng: -76.99176943663474,
          lat: -12.18764890838924,
        },
        {
          lng: -76.99172019249815,
          lat: -12.18634178980548,
        },
        {
          lng: -76.99209392960665,
          lat: -12.18585281116008,
        },
        {
          lng: -76.99158836390659,
          lat: -12.18538433554137,
        },
        {
          lng: -76.99207310610797,
          lat: -12.18488717220614,
        },
        {
          lng: -76.9924223256917,
          lat: -12.18522041429862,
        },
        {
          lng: -76.99270443528331,
          lat: -12.1850025779653,
        },
        {
          lng: -76.99299318237122,
          lat: -12.18540285371688,
        },
        {
          lng: -76.99326683353037,
          lat: -12.18565435550163,
        },
        {
          lng: -76.99328486075532,
          lat: -12.18587204838593,
        },
        {
          lng: -76.9933212893982,
          lat: -12.18599361274552,
        },
        {
          lng: -76.99344423118714,
          lat: -12.18607777321106,
        },
        {
          lng: -76.99353146765174,
          lat: -12.18607149606332,
        },
        {
          lng: -76.99364934852719,
          lat: -12.18573134133163,
        },
        {
          lng: -76.99385769877014,
          lat: -12.18551591658147,
        },
        {
          lng: -76.99457837599087,
          lat: -12.18611226020251,
        },
        {
          lng: -76.99473529028432,
          lat: -12.18599980341601,
        },
        {
          lng: -76.99544944554663,
          lat: -12.18666443287553,
        },
      ],
    },
    {
      ubigeo: '150108',
      name: 'BUENOS AIRES DE VILLA',
      poligonos: [
        {
          lng: -76.99915615970556,
          lat: -12.18497522979137,
        },
        {
          lng: -76.99940545095417,
          lat: -12.18475935068373,
        },
        {
          lng: -76.99976010767828,
          lat: -12.18459326295959,
        },
        {
          lng: -77.00001137220062,
          lat: -12.18451232803531,
        },
        {
          lng: -77.00138919615193,
          lat: -12.1844014002514,
        },
        {
          lng: -77.00202268451542,
          lat: -12.18438296618027,
        },
        {
          lng: -77.0026472878338,
          lat: -12.1845505701875,
        },
        {
          lng: -77.00298808217988,
          lat: -12.18475579406634,
        },
        {
          lng: -77.00316815335681,
          lat: -12.18451716493019,
        },
        {
          lng: -77.00340863110218,
          lat: -12.18465559392614,
        },
        {
          lng: -77.00374267613189,
          lat: -12.1851646393473,
        },
        {
          lng: -77.00502016783263,
          lat: -12.18506936964991,
        },
        {
          lng: -77.00519725995044,
          lat: -12.18507473022273,
        },
        {
          lng: -77.00541646450361,
          lat: -12.18515066631743,
        },
        {
          lng: -77.00610734384504,
          lat: -12.18725066005491,
        },
        {
          lng: -77.00591153386281,
          lat: -12.18734483704018,
        },
        {
          lng: -77.0057860856506,
          lat: -12.18752396033943,
        },
        {
          lng: -77.00572535306064,
          lat: -12.18769204906745,
        },
        {
          lng: -77.00576102916794,
          lat: -12.18827569148129,
        },
        {
          lng: -77.005418345389,
          lat: -12.18827049300985,
        },
        {
          lng: -77.00507398583471,
          lat: -12.18815228231296,
        },
        {
          lng: -77.0047894026169,
          lat: -12.1881058966126,
        },
        {
          lng: -77.0044436109432,
          lat: -12.18821522655595,
        },
        {
          lng: -77.00415873178295,
          lat: -12.1883699134434,
        },
        {
          lng: -77.00283435837407,
          lat: -12.18874676886714,
        },
        {
          lng: -77.00224179754761,
          lat: -12.18910350293825,
        },
        {
          lng: -77.00186218110011,
          lat: -12.18942987985661,
        },
        {
          lng: -77.00154745362727,
          lat: -12.18979018996604,
        },
        {
          lng: -77.00082114113549,
          lat: -12.19009058758368,
        },
        {
          lng: -77.00063566925249,
          lat: -12.19024603339914,
        },
        {
          lng: -77.00046614688607,
          lat: -12.19046898308717,
        },
        {
          lng: -77.00045599922491,
          lat: -12.1909517870897,
        },
        {
          lng: -77.00060782974568,
          lat: -12.191664280019,
        },
        {
          lng: -77.00068812603158,
          lat: -12.19224487868365,
        },
        {
          lng: -77.0006884200937,
          lat: -12.1926241271791,
        },
        {
          lng: -77.00077392794321,
          lat: -12.19309232288058,
        },
        {
          lng: -77.00132787916925,
          lat: -12.19440666462469,
        },
        {
          lng: -77.00161240932904,
          lat: -12.19467321075311,
        },
        {
          lng: -77.00185472760919,
          lat: -12.19482461236688,
        },
        {
          lng: -77.00160915918688,
          lat: -12.19508128894064,
        },
        {
          lng: -77.0013367846688,
          lat: -12.19476245832448,
        },
        {
          lng: -77.00111402537813,
          lat: -12.19466499418161,
        },
        {
          lng: -77.00065971477122,
          lat: -12.19419522804214,
        },
        {
          lng: -77.00039986509742,
          lat: -12.19371590696237,
        },
        {
          lng: -76.99977482247547,
          lat: -12.19263619667097,
        },
        {
          lng: -76.99966400796238,
          lat: -12.1922694290558,
        },
        {
          lng: -76.99951299548981,
          lat: -12.19144502494637,
        },
        {
          lng: -76.99938783994261,
          lat: -12.19112300620267,
        },
        {
          lng: -76.99923841758435,
          lat: -12.19085478657086,
        },
        {
          lng: -76.99901285817222,
          lat: -12.19062800379419,
        },
        {
          lng: -76.9987453821325,
          lat: -12.19044810476366,
        },
        {
          lng: -76.99866277550778,
          lat: -12.19055548424826,
        },
        {
          lng: -76.99782075483563,
          lat: -12.18997244053728,
        },
        {
          lng: -76.99697722880227,
          lat: -12.18951486818584,
        },
        {
          lng: -76.99691486286378,
          lat: -12.1895775467256,
        },
        {
          lng: -76.99626068121549,
          lat: -12.18884096744451,
        },
        {
          lng: -76.9963075877209,
          lat: -12.1887949625896,
        },
        {
          lng: -76.99621322513887,
          lat: -12.18769833117763,
        },
        {
          lng: -76.99614890471528,
          lat: -12.18741355622569,
        },
        {
          lng: -76.9958578115308,
          lat: -12.18740345561875,
        },
        {
          lng: -76.99571175249453,
          lat: -12.18728484501913,
        },
        {
          lng: -76.99582053078787,
          lat: -12.18714229529964,
        },
        {
          lng: -76.99534467031016,
          lat: -12.18677865563381,
        },
        {
          lng: -76.9954430003915,
          lat: -12.18666807709837,
        },
        {
          lng: -76.99472988956886,
          lat: -12.18600133245892,
        },
        {
          lng: -76.99514212366999,
          lat: -12.18551408604356,
        },
        {
          lng: -76.99641027588595,
          lat: -12.18672806168687,
        },
        {
          lng: -76.99801378711578,
          lat: -12.18523527538315,
        },
        {
          lng: -76.99865346939237,
          lat: -12.18582241481062,
        },
        {
          lng: -77.00590692320083,
          lat: -12.18542057816233,
        },
        {
          lng: -77.00675137018766,
          lat: -12.18582770500969,
        },
        {
          lng: -77.0069164710047,
          lat: -12.18606973693069,
        },
        {
          lng: -77.00694282876405,
          lat: -12.18633146553351,
        },
        {
          lng: -77.00693295887156,
          lat: -12.18674183640346,
        },
        {
          lng: -77.00679680765262,
          lat: -12.18690085264413,
        },
        {
          lng: -77.00649578106044,
          lat: -12.18712236575034,
        },
      ],
    },
    {
      ubigeo: '150108',
      name: 'DELICIAS DE VILLA',
      poligonos: [
        {
          lng: -77.00140556428285,
          lat: -12.19527240089032,
        },
        {
          lng: -76.99973382717101,
          lat: -12.19491869531615,
        },
        {
          lng: -76.99945102721358,
          lat: -12.19489228337515,
        },
        {
          lng: -76.99914586084242,
          lat: -12.19490681150156,
        },
        {
          lng: -76.99885609297127,
          lat: -12.19501470401405,
        },
        {
          lng: -76.99839687563906,
          lat: -12.19534410507451,
        },
        {
          lng: -76.99813432296453,
          lat: -12.19579227191292,
        },
        {
          lng: -76.99803194716365,
          lat: -12.19609914129712,
        },
        {
          lng: -76.99784076155952,
          lat: -12.19652615468079,
        },
        {
          lng: -76.99748562689271,
          lat: -12.19677318017221,
        },
        {
          lng: -76.99687169257415,
          lat: -12.197113138026,
        },
        {
          lng: -76.9949813994945,
          lat: -12.19873813425696,
        },
        {
          lng: -76.99566116145493,
          lat: -12.1994950897177,
        },
        {
          lng: -76.99623019434645,
          lat: -12.19892384763924,
        },
        {
          lng: -76.99697649042176,
          lat: -12.19978825193915,
        },
        {
          lng: -76.99108302974447,
          lat: -12.20566861605604,
        },
        {
          lng: -76.99051545043734,
          lat: -12.20511965731284,
        },
        {
          lng: -76.9901976898841,
          lat: -12.20522847952235,
        },
        {
          lng: -76.98990577567032,
          lat: -12.20524063017083,
        },
        {
          lng: -76.98931915080115,
          lat: -12.20474622755972,
        },
        {
          lng: -76.98813173691175,
          lat: -12.20495171511478,
        },
        {
          lng: -76.98748897629224,
          lat: -12.20501883645869,
        },
        {
          lng: -76.98694270371334,
          lat: -12.20500495295667,
        },
        {
          lng: -76.98685770863156,
          lat: -12.20531994404943,
        },
        {
          lng: -76.98678346073476,
          lat: -12.20546025485036,
        },
        {
          lng: -76.98657508741165,
          lat: -12.20511928477865,
        },
        {
          lng: -76.98586702746721,
          lat: -12.20430076434117,
        },
        {
          lng: -76.98510407025813,
          lat: -12.20346174084578,
        },
        {
          lng: -76.9843549792323,
          lat: -12.202949267994,
        },
        {
          lng: -76.98391221568511,
          lat: -12.20281592799286,
        },
        {
          lng: -76.98297355683223,
          lat: -12.20336068520213,
        },
        {
          lng: -76.98008672974022,
          lat: -12.20061551142578,
        },
        {
          lng: -76.98091646245274,
          lat: -12.19980251366792,
        },
        {
          lng: -76.98147383349308,
          lat: -12.20036211706935,
        },
        {
          lng: -76.98182809379911,
          lat: -12.19928313347381,
        },
        {
          lng: -76.98162152123936,
          lat: -12.19909979544478,
        },
        {
          lng: -76.98533647974489,
          lat: -12.19552356793684,
        },
        {
          lng: -76.98556467379369,
          lat: -12.19574159864383,
        },
        {
          lng: -76.98819504913384,
          lat: -12.1931815163737,
        },
        {
          lng: -76.98966576783099,
          lat: -12.19211834934754,
        },
        {
          lng: -76.99050437867591,
          lat: -12.19145588514884,
        },
        {
          lng: -76.99072577759406,
          lat: -12.19116050347175,
        },
        {
          lng: -76.99176889039143,
          lat: -12.19150639247001,
        },
        {
          lng: -76.99215142422051,
          lat: -12.19195228215117,
        },
        {
          lng: -76.99317282064082,
          lat: -12.1909732790899,
        },
        {
          lng: -76.99357306636023,
          lat: -12.19134448629884,
        },
        {
          lng: -76.99454469745946,
          lat: -12.19040445289463,
        },
        {
          lng: -76.99457537341159,
          lat: -12.19027711399767,
        },
        {
          lng: -76.99453615166718,
          lat: -12.19004058096469,
        },
        {
          lng: -76.994446639973,
          lat: -12.18989590512935,
        },
        {
          lng: -76.99413695135738,
          lat: -12.18956169099719,
        },
        {
          lng: -76.99451216206364,
          lat: -12.18928305538798,
        },
        {
          lng: -76.99459858893812,
          lat: -12.18918104646045,
        },
        {
          lng: -76.99592147300541,
          lat: -12.18911247627507,
        },
        {
          lng: -76.99626696900303,
          lat: -12.18884082415187,
        },
        {
          lng: -76.99691156237527,
          lat: -12.1895862483431,
        },
        {
          lng: -76.99698461536899,
          lat: -12.18950003391529,
        },
        {
          lng: -76.99787950572983,
          lat: -12.18999503039347,
        },
        {
          lng: -76.99869015912019,
          lat: -12.19056190008108,
        },
        {
          lng: -76.99874020372482,
          lat: -12.190438716518,
        },
        {
          lng: -76.99926118425206,
          lat: -12.19082398332131,
        },
        {
          lng: -76.99952728315047,
          lat: -12.19151163456577,
        },
        {
          lng: -76.9997338480329,
          lat: -12.19254603728793,
        },
        {
          lng: -77.00068099382244,
          lat: -12.19417656183401,
        },
        {
          lng: -77.00112776708734,
          lat: -12.19466990812174,
        },
        {
          lng: -77.00128822932193,
          lat: -12.19474634066371,
        },
        {
          lng: -77.00159365280858,
          lat: -12.19505258166248,
        },
      ],
    },
    {
      ubigeo: '150108',
      name: 'SANTA ISABEL DE VILLA',
      poligonos: [
        {
          lng: -76.97795471812911,
          lat: -12.19861923990113,
        },
        {
          lng: -76.98338077936162,
          lat: -12.20379750412727,
        },
        {
          lng: -76.98073544503201,
          lat: -12.20648273299294,
        },
        {
          lng: -76.97961853543036,
          lat: -12.20538466705583,
        },
        {
          lng: -76.97944038795748,
          lat: -12.20529603196327,
        },
        {
          lng: -76.97892677596,
          lat: -12.20568978431482,
        },
        {
          lng: -76.97792071416531,
          lat: -12.20474408433708,
        },
        {
          lng: -76.97666385128322,
          lat: -12.20345542763802,
        },
        {
          lng: -76.9757944421104,
          lat: -12.20267506434468,
        },
        {
          lng: -76.9751906290197,
          lat: -12.20209328498816,
        },
        {
          lng: -76.97513650781343,
          lat: -12.20187509372525,
        },
        {
          lng: -76.97516554656673,
          lat: -12.20167003088171,
        },
        {
          lng: -76.97545658933636,
          lat: -12.20145698429719,
        },
        {
          lng: -76.97555638714883,
          lat: -12.20127944449355,
        },
        {
          lng: -76.97609139551736,
          lat: -12.20076565110197,
        },
        {
          lng: -76.97622685728925,
          lat: -12.20050024165209,
        },
        {
          lng: -76.976756739978,
          lat: -12.20012473497321,
        },
        {
          lng: -76.97710514765294,
          lat: -12.1996873916871,
        },
        {
          lng: -76.97720288149749,
          lat: -12.19929215415058,
        },
        {
          lng: -76.97721101589063,
          lat: -12.19885240905051,
        },
        {
          lng: -76.97737192389431,
          lat: -12.19868690413702,
        },
      ],
    },
    {
      ubigeo: '150109',
      name: 'CIENEGUILLA',
      poligonos: [
        {
          lng: -76.72241639069283,
          lat: -12.00012779297619,
        },
        {
          lng: -76.72629920283819,
          lat: -11.9998015059282,
        },
        {
          lng: -76.74772431736753,
          lat: -12.0202976927426,
        },
        {
          lng: -76.77683220751338,
          lat: -12.02463327857506,
        },
        {
          lng: -76.78831005120226,
          lat: -12.02391123173864,
        },
        {
          lng: -76.79054208611905,
          lat: -12.01839046828009,
        },
        {
          lng: -76.80807394801965,
          lat: -12.03795139178531,
        },
        {
          lng: -76.82816461886588,
          lat: -12.04306359800623,
        },
        {
          lng: -76.83035051486695,
          lat: -12.03948026833301,
        },
        {
          lng: -76.8353645579975,
          lat: -12.03660413836272,
        },
        {
          lng: -76.84015653682702,
          lat: -12.03623217120348,
        },
        {
          lng: -76.84658692601936,
          lat: -12.03700566504335,
        },
        {
          lng: -76.88679515229643,
          lat: -12.05939588838227,
        },
        {
          lng: -76.8776590146518,
          lat: -12.07457447762457,
        },
        {
          lng: -76.87468246849886,
          lat: -12.07821835645383,
        },
        {
          lng: -76.87127911083417,
          lat: -12.08664678840297,
        },
        {
          lng: -76.82968810016801,
          lat: -12.13068941781352,
        },
        {
          lng: -76.82211058647772,
          lat: -12.13276315448774,
        },
        {
          lng: -76.81709033243881,
          lat: -12.13319973588746,
        },
        {
          lng: -76.79365677322573,
          lat: -12.13991880214632,
        },
        {
          lng: -76.78675136149731,
          lat: -12.14003626992854,
        },
        {
          lng: -76.77125604546023,
          lat: -12.13481650385075,
        },
        {
          lng: -76.75091247341435,
          lat: -12.13531592978232,
        },
        {
          lng: -76.72133900824277,
          lat: -12.12309329467793,
        },
        {
          lng: -76.71568954577069,
          lat: -12.11875693894696,
        },
        {
          lng: -76.70740842363787,
          lat: -12.11415540317108,
        },
        {
          lng: -76.70469625166025,
          lat: -12.10616020648104,
        },
        {
          lng: -76.70713242802418,
          lat: -12.10074448714421,
        },
        {
          lng: -76.70835532067576,
          lat: -12.09624035757822,
        },
        {
          lng: -76.70792101769942,
          lat: -12.09135363381522,
        },
        {
          lng: -76.70637714412462,
          lat: -12.08744577071972,
        },
        {
          lng: -76.70454178578359,
          lat: -12.0860634078939,
        },
        {
          lng: -76.69571812030127,
          lat: -12.08804996799655,
        },
        {
          lng: -76.68949855950589,
          lat: -12.08613125023871,
        },
        {
          lng: -76.68059928348028,
          lat: -12.08136985604954,
        },
        {
          lng: -76.67792884709986,
          lat: -12.07745021136357,
        },
        {
          lng: -76.67031930568177,
          lat: -12.06956690134027,
        },
        {
          lng: -76.66627580462465,
          lat: -12.06836938980692,
        },
        {
          lng: -76.65476557060128,
          lat: -12.07145630846763,
        },
        {
          lng: -76.64295719091581,
          lat: -12.06852321427074,
        },
        {
          lng: -76.64311595102166,
          lat: -12.06677584488467,
        },
        {
          lng: -76.65324289832232,
          lat: -12.0568939233957,
        },
        {
          lng: -76.66039366867201,
          lat: -12.05180839093431,
        },
        {
          lng: -76.6645125600161,
          lat: -12.04980429308468,
        },
        {
          lng: -76.67001529782046,
          lat: -12.04643095514037,
        },
        {
          lng: -76.68232144785404,
          lat: -12.04000507210378,
        },
        {
          lng: -76.68558065796253,
          lat: -12.03662337426407,
        },
        {
          lng: -76.68868115795061,
          lat: -12.02834455409099,
        },
        {
          lng: -76.70318078882175,
          lat: -12.02929275120639,
        },
        {
          lng: -76.71612131765693,
          lat: -12.03516028360447,
        },
        {
          lng: -76.72049745823058,
          lat: -12.03573513543684,
        },
        {
          lng: -76.726735871007,
          lat: -12.02715946843545,
        },
        {
          lng: -76.72434103167417,
          lat: -12.00646228436158,
        },
      ],
    },
    {
      ubigeo: '150111',
      name: 'EL AGUSTINO',
      poligonos: [
        {
          lng: -76.9551255945987,
          lat: -12.02880196985573,
        },
        {
          lng: -76.95474287534209,
          lat: -12.02821083566608,
        },
        {
          lng: -76.9542794715973,
          lat: -12.02759763713605,
        },
        {
          lng: -76.95382993839391,
          lat: -12.02729012122288,
        },
        {
          lng: -76.95372107315882,
          lat: -12.02697004594593,
        },
        {
          lng: -76.9534080846525,
          lat: -12.02682308545131,
        },
        {
          lng: -76.95306764253759,
          lat: -12.02593085331402,
        },
        {
          lng: -76.95270291832387,
          lat: -12.0255364622178,
        },
        {
          lng: -76.95281274617335,
          lat: -12.02515086025971,
        },
        {
          lng: -76.95234701248846,
          lat: -12.02475002945909,
        },
        {
          lng: -76.95172007349296,
          lat: -12.02470936815688,
        },
        {
          lng: -76.95155695438343,
          lat: -12.02445676842479,
        },
        {
          lng: -76.95106760572617,
          lat: -12.02441688561467,
        },
        {
          lng: -76.95041531671087,
          lat: -12.02417775883097,
        },
        {
          lng: -76.95019761344413,
          lat: -12.02439021455865,
        },
        {
          lng: -76.94991216082363,
          lat: -12.02444317118486,
        },
        {
          lng: -76.94938218839751,
          lat: -12.02421728489775,
        },
        {
          lng: -76.94917875193333,
          lat: -12.02445592332597,
        },
        {
          lng: -76.94870381136431,
          lat: -12.0242830009218,
        },
        {
          lng: -76.94786378220803,
          lat: -12.02403030038041,
        },
        {
          lng: -76.94727049935742,
          lat: -12.02406936130093,
        },
        {
          lng: -76.94709391164913,
          lat: -12.02379120123979,
        },
        {
          lng: -76.95194133127552,
          lat: -12.02153891880783,
        },
        {
          lng: -76.96323313503514,
          lat: -12.02522674012721,
        },
        {
          lng: -76.96835615532919,
          lat: -12.02658549815366,
        },
        {
          lng: -76.97181310182471,
          lat: -12.02625706264015,
        },
        {
          lng: -76.97477326397349,
          lat: -12.0263649108891,
        },
        {
          lng: -76.980865856992,
          lat: -12.02556171051946,
        },
        {
          lng: -76.98235356806097,
          lat: -12.02562849185811,
        },
        {
          lng: -76.98741562147771,
          lat: -12.02669835829206,
        },
        {
          lng: -76.99037236815605,
          lat: -12.02692857680483,
        },
        {
          lng: -76.99559802415911,
          lat: -12.02688182434984,
        },
        {
          lng: -77.00096393998727,
          lat: -12.02822711069513,
        },
        {
          lng: -77.00410602871159,
          lat: -12.02946437677855,
        },
        {
          lng: -77.00616090481537,
          lat: -12.02976761194657,
        },
        {
          lng: -77.0077926625528,
          lat: -12.03019660170187,
        },
        {
          lng: -77.0089857356187,
          lat: -12.03040689714655,
        },
        {
          lng: -77.00978263413917,
          lat: -12.03063372518837,
        },
        {
          lng: -77.00825984748032,
          lat: -12.0331985767717,
        },
        {
          lng: -77.00898951889945,
          lat: -12.03383047428104,
        },
        {
          lng: -77.00716563326523,
          lat: -12.03609176112083,
        },
        {
          lng: -77.00572692963485,
          lat: -12.03756257103549,
        },
        {
          lng: -77.00554386224705,
          lat: -12.03873302943858,
        },
        {
          lng: -77.00302219434614,
          lat: -12.04690530715363,
        },
        {
          lng: -77.00396096158202,
          lat: -12.04732632341264,
        },
        {
          lng: -77.00444654541262,
          lat: -12.04771829136384,
        },
        {
          lng: -77.00507378166125,
          lat: -12.04790225087307,
        },
        {
          lng: -77.00501752656174,
          lat: -12.04816709001806,
        },
        {
          lng: -77.00681938941072,
          lat: -12.04957580393327,
        },
        {
          lng: -77.00729271078278,
          lat: -12.04902980105961,
        },
        {
          lng: -77.00759414105529,
          lat: -12.04891889966819,
        },
        {
          lng: -77.00842707680592,
          lat: -12.04760026472417,
        },
        {
          lng: -77.00812504434552,
          lat: -12.04724829395658,
        },
        {
          lng: -77.00840930612532,
          lat: -12.04679666208857,
        },
        {
          lng: -77.00694650315494,
          lat: -12.04294635213621,
        },
        {
          lng: -77.00723252047199,
          lat: -12.04283327824458,
        },
        {
          lng: -77.007418550164,
          lat: -12.04262274885836,
        },
        {
          lng: -77.01097749864002,
          lat: -12.04380091734153,
        },
        {
          lng: -77.01083266139217,
          lat: -12.04477168322091,
        },
        {
          lng: -77.01111662737638,
          lat: -12.04604039428195,
        },
        {
          lng: -77.01098399404887,
          lat: -12.04724510802819,
        },
        {
          lng: -77.01104352858862,
          lat: -12.04849570354601,
        },
        {
          lng: -77.01126087407823,
          lat: -12.04995988648199,
        },
        {
          lng: -77.0115821377362,
          lat: -12.05116865479205,
        },
        {
          lng: -77.01238648222011,
          lat: -12.05353145378484,
        },
        {
          lng: -77.0102062764728,
          lat: -12.05628398375477,
        },
        {
          lng: -77.00867550397227,
          lat: -12.05768493633731,
        },
        {
          lng: -77.0079767669772,
          lat: -12.05815407522271,
        },
        {
          lng: -77.00741188026942,
          lat: -12.05870320745043,
        },
        {
          lng: -77.0070588592828,
          lat: -12.05967860296479,
        },
        {
          lng: -77.00635467632046,
          lat: -12.06049537639005,
        },
        {
          lng: -77.00599564771207,
          lat: -12.06070673457123,
        },
        {
          lng: -77.00512917581592,
          lat: -12.06062224742345,
        },
        {
          lng: -77.00458202043984,
          lat: -12.06070675958364,
        },
        {
          lng: -77.00400522984184,
          lat: -12.06065047288831,
        },
        {
          lng: -77.00354460481174,
          lat: -12.06076308211301,
        },
        {
          lng: -77.0024373690003,
          lat: -12.06129721329847,
        },
        {
          lng: -77.00197752191636,
          lat: -12.06163448533733,
        },
        {
          lng: -77.00206207549658,
          lat: -12.06179061449724,
        },
        {
          lng: -77.00294006010867,
          lat: -12.06157954578463,
        },
        {
          lng: -77.00322982098014,
          lat: -12.06258563535403,
        },
        {
          lng: -77.00190538065344,
          lat: -12.06310484791517,
        },
        {
          lng: -77.00105805652272,
          lat: -12.06329022905925,
        },
        {
          lng: -76.99747776199094,
          lat: -12.06374828561694,
        },
        {
          lng: -76.99390876395184,
          lat: -12.06397727380634,
        },
        {
          lng: -76.99015447298741,
          lat: -12.06432967399216,
        },
        {
          lng: -76.98887720950069,
          lat: -12.06433282076648,
        },
        {
          lng: -76.98208195093002,
          lat: -12.06312248505383,
        },
        {
          lng: -76.98172266150506,
          lat: -12.06291812340454,
        },
        {
          lng: -76.97879919048599,
          lat: -12.06094085918031,
        },
        {
          lng: -76.97334948463214,
          lat: -12.0584730849603,
        },
        {
          lng: -76.97535098911284,
          lat: -12.05380006593375,
        },
        {
          lng: -76.97816876658128,
          lat: -12.0548987448862,
        },
        {
          lng: -76.98127023437173,
          lat: -12.05513012932081,
        },
        {
          lng: -76.98191728070464,
          lat: -12.05534717929993,
        },
        {
          lng: -76.98245624335678,
          lat: -12.05539447284982,
        },
        {
          lng: -76.98309204549479,
          lat: -12.05581365479426,
        },
        {
          lng: -76.98377454713082,
          lat: -12.05576413463139,
        },
        {
          lng: -76.98495653268365,
          lat: -12.05522406745181,
        },
        {
          lng: -76.98732385272324,
          lat: -12.05366157726983,
        },
        {
          lng: -76.9881860805711,
          lat: -12.05270083502744,
        },
        {
          lng: -76.98870262528483,
          lat: -12.05123079413959,
        },
        {
          lng: -76.98860148040112,
          lat: -12.04971363032072,
        },
        {
          lng: -76.98740301779249,
          lat: -12.04773268269058,
        },
        {
          lng: -76.98586605413368,
          lat: -12.04730641335905,
        },
        {
          lng: -76.98474225534873,
          lat: -12.04433880633421,
        },
        {
          lng: -76.98619634566339,
          lat: -12.04301021811697,
        },
        {
          lng: -76.98731965721196,
          lat: -12.04147462958614,
        },
        {
          lng: -76.98781154714065,
          lat: -12.04040237637127,
        },
        {
          lng: -76.98807814019636,
          lat: -12.03952730973627,
        },
        {
          lng: -76.986531039866,
          lat: -12.03969075178154,
        },
        {
          lng: -76.98518539602,
          lat: -12.0399871863141,
        },
        {
          lng: -76.98451537875694,
          lat: -12.03948967483886,
        },
        {
          lng: -76.98354241796333,
          lat: -12.04000103426941,
        },
        {
          lng: -76.98165329945216,
          lat: -12.04037956331895,
        },
        {
          lng: -76.97719187832678,
          lat: -12.04048345476651,
        },
        {
          lng: -76.97578336729853,
          lat: -12.04041612686644,
        },
        {
          lng: -76.9747118792935,
          lat: -12.04017080611362,
        },
        {
          lng: -76.97377215978744,
          lat: -12.03970303484649,
        },
        {
          lng: -76.9628558299733,
          lat: -12.03148877740637,
        },
        {
          lng: -76.96221248156334,
          lat: -12.03112633454407,
        },
        {
          lng: -76.96061630221887,
          lat: -12.03043698823465,
        },
        {
          lng: -76.95994426711184,
          lat: -12.03036962855813,
        },
        {
          lng: -76.95546677738737,
          lat: -12.02964283536002,
        },
        {
          lng: -76.9461774992459,
          lat: -12.02343358287052,
        },
        {
          lng: -76.94501561171423,
          lat: -12.02323518324846,
        },
        {
          lng: -76.94539248558742,
          lat: -12.02079158001929,
        },
      ],
    },
    {
      ubigeo: '150123',
      name: 'PACHACAMAC',
      poligonos: [
        {
          lng: -76.89069601045314,
          lat: -12.07490408649931,
        },
        {
          lng: -76.88877538639971,
          lat: -12.07643386112683,
        },
        {
          lng: -76.88659613888532,
          lat: -12.07635190467031,
        },
        {
          lng: -76.88641090234742,
          lat: -12.08180034997834,
        },
        {
          lng: -76.88720825684965,
          lat: -12.08526848011812,
        },
        {
          lng: -76.8836645599483,
          lat: -12.08930839996585,
        },
        {
          lng: -76.88558689112726,
          lat: -12.09240263671207,
        },
        {
          lng: -76.88816782613443,
          lat: -12.09188197361637,
        },
        {
          lng: -76.89239345133285,
          lat: -12.09361851020525,
        },
        {
          lng: -76.8908360083385,
          lat: -12.09722762009773,
        },
        {
          lng: -76.89090320427516,
          lat: -12.10084844099769,
        },
        {
          lng: -76.89484013625766,
          lat: -12.10563076697744,
        },
        {
          lng: -76.89927066448976,
          lat: -12.10909581485692,
        },
        {
          lng: -76.90355771055413,
          lat: -12.1144694446578,
        },
        {
          lng: -76.91258021972854,
          lat: -12.11444532968455,
        },
        {
          lng: -76.91585421309637,
          lat: -12.11570199989095,
        },
        {
          lng: -76.91643961221264,
          lat: -12.11889186176232,
        },
        {
          lng: -76.91100987646517,
          lat: -12.12156838195687,
        },
        {
          lng: -76.90735287200161,
          lat: -12.12484489481606,
        },
        {
          lng: -76.90892299018104,
          lat: -12.13042331451253,
        },
        {
          lng: -76.9051648615683,
          lat: -12.13480511258559,
        },
        {
          lng: -76.90145175402422,
          lat: -12.13703990597794,
        },
        {
          lng: -76.8967416833114,
          lat: -12.15190010988942,
        },
        {
          lng: -76.89725162700265,
          lat: -12.15964919079459,
        },
        {
          lng: -76.89466244267052,
          lat: -12.16518693033688,
        },
        {
          lng: -76.88570976970925,
          lat: -12.1787226685455,
        },
        {
          lng: -76.8864806719917,
          lat: -12.18341234242376,
        },
        {
          lng: -76.88939959669571,
          lat: -12.18779282784112,
        },
        {
          lng: -76.8941200769943,
          lat: -12.19658614305092,
        },
        {
          lng: -76.89609189666025,
          lat: -12.20213632071462,
        },
        {
          lng: -76.89407069834596,
          lat: -12.20608247076993,
        },
        {
          lng: -76.89633595791634,
          lat: -12.21268349922613,
        },
        {
          lng: -76.89733591673723,
          lat: -12.21581285315313,
        },
        {
          lng: -76.89515536070269,
          lat: -12.21579380344943,
        },
        {
          lng: -76.86898504036432,
          lat: -12.23058553835008,
        },
        {
          lng: -76.87188348590617,
          lat: -12.23428399580743,
        },
        {
          lng: -76.86844271054531,
          lat: -12.23646378734883,
        },
        {
          lng: -76.87035583383174,
          lat: -12.24093371579523,
        },
        {
          lng: -76.86812851781914,
          lat: -12.24202158286568,
        },
        {
          lng: -76.86699507623413,
          lat: -12.23885607900867,
        },
        {
          lng: -76.86543433109932,
          lat: -12.23928984217421,
        },
        {
          lng: -76.86362981622361,
          lat: -12.23645000818756,
        },
        {
          lng: -76.86230358557368,
          lat: -12.23438949286953,
        },
        {
          lng: -76.85862251850716,
          lat: -12.23642645838493,
        },
        {
          lng: -76.8541053685894,
          lat: -12.23070433457936,
        },
        {
          lng: -76.85551007803812,
          lat: -12.22738088040676,
        },
        {
          lng: -76.8550818957548,
          lat: -12.22532677966832,
        },
        {
          lng: -76.8526880505647,
          lat: -12.22562580602834,
        },
        {
          lng: -76.8507195801685,
          lat: -12.22715570025148,
        },
        {
          lng: -76.84916826535019,
          lat: -12.22997509476725,
        },
        {
          lng: -76.84771036769361,
          lat: -12.22888233761111,
        },
        {
          lng: -76.84425820902769,
          lat: -12.2289818822588,
        },
        {
          lng: -76.84296951215792,
          lat: -12.22796425376161,
        },
        {
          lng: -76.84299669054295,
          lat: -12.22549302790729,
        },
        {
          lng: -76.84264217176593,
          lat: -12.2215888813251,
        },
        {
          lng: -76.84409127912157,
          lat: -12.21921413865537,
        },
        {
          lng: -76.8422840260589,
          lat: -12.21758044098291,
        },
        {
          lng: -76.83720770656474,
          lat: -12.21543979464608,
        },
        {
          lng: -76.83252131929656,
          lat: -12.21595282307251,
        },
        {
          lng: -76.82836648958155,
          lat: -12.21472612621805,
        },
        {
          lng: -76.8243317872242,
          lat: -12.2118899841168,
        },
        {
          lng: -76.82230762132673,
          lat: -12.20907349141432,
        },
        {
          lng: -76.81828436219485,
          lat: -12.2053918356955,
        },
        {
          lng: -76.8173710303278,
          lat: -12.20152051788533,
        },
        {
          lng: -76.81569137943188,
          lat: -12.19947404161461,
        },
        {
          lng: -76.79740810986517,
          lat: -12.19365663472994,
        },
        {
          lng: -76.79445125664253,
          lat: -12.19046337774799,
        },
        {
          lng: -76.79422058605871,
          lat: -12.18855124100079,
        },
        {
          lng: -76.79300614004421,
          lat: -12.1859012398034,
        },
        {
          lng: -76.79169989371262,
          lat: -12.18389062371308,
        },
        {
          lng: -76.78865401324065,
          lat: -12.18209788491173,
        },
        {
          lng: -76.78615924400349,
          lat: -12.17861825818498,
        },
        {
          lng: -76.78593725064086,
          lat: -12.17609285558411,
        },
        {
          lng: -76.77305500503924,
          lat: -12.17050115059425,
        },
        {
          lng: -76.76439949799854,
          lat: -12.17167570813492,
        },
        {
          lng: -76.75209809581432,
          lat: -12.17183174846241,
        },
        {
          lng: -76.74187115152507,
          lat: -12.16829064829753,
        },
        {
          lng: -76.73135397383817,
          lat: -12.16105720033003,
        },
        {
          lng: -76.72535880803821,
          lat: -12.16084792032775,
        },
        {
          lng: -76.7173680087058,
          lat: -12.16493580867895,
        },
        {
          lng: -76.71194899445784,
          lat: -12.16911416488633,
        },
        {
          lng: -76.70601714815217,
          lat: -12.17703051999023,
        },
        {
          lng: -76.69664970113269,
          lat: -12.1796584885678,
        },
        {
          lng: -76.68883717671677,
          lat: -12.17847962573444,
        },
        {
          lng: -76.68494089900936,
          lat: -12.17595715840673,
        },
        {
          lng: -76.67769825941734,
          lat: -12.17565902601148,
        },
        {
          lng: -76.66655378920035,
          lat: -12.1811764076485,
        },
        {
          lng: -76.66552574778406,
          lat: -12.17831218815866,
        },
        {
          lng: -76.66661062936188,
          lat: -12.17522388018514,
        },
        {
          lng: -76.67516403453804,
          lat: -12.1676165032119,
        },
        {
          lng: -76.68459806628843,
          lat: -12.15800678932573,
        },
        {
          lng: -76.69190271775061,
          lat: -12.14644813561934,
        },
        {
          lng: -76.6922217605459,
          lat: -12.14335185577062,
        },
        {
          lng: -76.69138526860213,
          lat: -12.14008663367462,
        },
        {
          lng: -76.68563546647466,
          lat: -12.13605366214101,
        },
        {
          lng: -76.6804298676027,
          lat: -12.13201709799975,
        },
        {
          lng: -76.6768535000045,
          lat: -12.12592148320392,
        },
        {
          lng: -76.67750689072271,
          lat: -12.1226990714425,
        },
        {
          lng: -76.67972351512196,
          lat: -12.11938206176542,
        },
        {
          lng: -76.68477572193358,
          lat: -12.11349939272259,
        },
        {
          lng: -76.69038959315814,
          lat: -12.1106302973333,
        },
        {
          lng: -76.69765863415914,
          lat: -12.11044509961517,
        },
        {
          lng: -76.70779413624103,
          lat: -12.1133336663789,
        },
        {
          lng: -76.71487177929642,
          lat: -12.11810402091277,
        },
        {
          lng: -76.72060365657472,
          lat: -12.12259552059577,
        },
        {
          lng: -76.72725498127106,
          lat: -12.12493456173881,
        },
        {
          lng: -76.75098083374743,
          lat: -12.13531338390401,
        },
        {
          lng: -76.77143849940636,
          lat: -12.13469396976795,
        },
        {
          lng: -76.78693873331999,
          lat: -12.14019859957056,
        },
        {
          lng: -76.79392437708981,
          lat: -12.14003604702994,
        },
        {
          lng: -76.8166156621899,
          lat: -12.13330889110893,
        },
        {
          lng: -76.82230499613294,
          lat: -12.13268887850172,
        },
        {
          lng: -76.83003472607177,
          lat: -12.13021182680357,
        },
        {
          lng: -76.83717752002691,
          lat: -12.12269206212022,
        },
        {
          lng: -76.87116435865518,
          lat: -12.08583945113567,
        },
        {
          lng: -76.87474175068812,
          lat: -12.07830258979388,
        },
        {
          lng: -76.87978482470383,
          lat: -12.0714453780587,
        },
        {
          lng: -76.88688316117796,
          lat: -12.05885393248731,
        },
        {
          lng: -76.89260396263823,
          lat: -12.0621430993161,
        },
      ],
    },
    {
      ubigeo: '150128',
      name: 'RIMAC',
      poligonos: [
        {
          lng: -77.05055374764893,
          lat: -12.02238223139748,
        },
        {
          lng: -77.05027738589081,
          lat: -12.02290569634927,
        },
        {
          lng: -77.04421935614714,
          lat: -12.02838913112597,
        },
        {
          lng: -77.04342182345934,
          lat: -12.03887382543686,
        },
        {
          lng: -77.04061927902693,
          lat: -12.03881483393638,
        },
        {
          lng: -77.03974074673818,
          lat: -12.03889363041585,
        },
        {
          lng: -77.0376633843066,
          lat: -12.03977983199111,
        },
        {
          lng: -77.03575167600643,
          lat: -12.0408229347732,
        },
        {
          lng: -77.03488684291835,
          lat: -12.04105875715607,
        },
        {
          lng: -77.03429746433025,
          lat: -12.04107455531448,
        },
        {
          lng: -77.02910279582707,
          lat: -12.04330662013958,
        },
        {
          lng: -77.02567601288875,
          lat: -12.04341988703985,
        },
        {
          lng: -77.02300589741041,
          lat: -12.04356942831856,
        },
        {
          lng: -77.01926598205304,
          lat: -12.04418985895498,
        },
        {
          lng: -77.018488385604,
          lat: -12.04416983862029,
        },
        {
          lng: -77.01711305569403,
          lat: -12.04389581519971,
        },
        {
          lng: -77.01603735632567,
          lat: -12.04342626159609,
        },
        {
          lng: -77.01490389782175,
          lat: -12.0424692663308,
        },
        {
          lng: -77.01395127393721,
          lat: -12.04133977671729,
        },
        {
          lng: -77.01357760000441,
          lat: -12.04068573695131,
        },
        {
          lng: -77.01257124880969,
          lat: -12.03708968922539,
        },
        {
          lng: -77.01504196792496,
          lat: -12.03691991050842,
        },
        {
          lng: -77.01630946507686,
          lat: -12.03627383289064,
        },
        {
          lng: -77.01930922511548,
          lat: -12.03203407369205,
        },
        {
          lng: -77.02155284766529,
          lat: -12.02909673072203,
        },
        {
          lng: -77.02208856020177,
          lat: -12.02758816217243,
        },
        {
          lng: -77.02215406442225,
          lat: -12.02542412722263,
        },
        {
          lng: -77.02031591269035,
          lat: -12.02369877346066,
        },
        {
          lng: -77.0194496983893,
          lat: -12.02042315289467,
        },
        {
          lng: -77.020601485256,
          lat: -12.01977060090051,
        },
        {
          lng: -77.02003426490433,
          lat: -12.01563770930681,
        },
        {
          lng: -77.02285417579307,
          lat: -12.01236533939417,
        },
        {
          lng: -77.02534386645496,
          lat: -12.01044089160689,
        },
        {
          lng: -77.0268257274576,
          lat: -12.00808569919815,
        },
        {
          lng: -77.02728247899432,
          lat: -12.00731251409123,
        },
        {
          lng: -77.02811102203043,
          lat: -12.00640681714458,
        },
        {
          lng: -77.03323627701853,
          lat: -12.00067161566668,
        },
        {
          lng: -77.03595454980042,
          lat: -11.99801030317484,
        },
        {
          lng: -77.03683704387038,
          lat: -12.00283098211918,
        },
        {
          lng: -77.0398963930269,
          lat: -12.00539496506416,
        },
        {
          lng: -77.04241520726306,
          lat: -12.00843054237863,
        },
        {
          lng: -77.04407848847771,
          lat: -12.01064272636277,
        },
        {
          lng: -77.04502305316973,
          lat: -12.01312045650572,
        },
        {
          lng: -77.04597293074237,
          lat: -12.01440254006725,
        },
        {
          lng: -77.04588145019038,
          lat: -12.01627241865451,
        },
        {
          lng: -77.0466894097071,
          lat: -12.01651854006474,
        },
        {
          lng: -77.04750709624234,
          lat: -12.01691430843359,
        },
        {
          lng: -77.04764424725624,
          lat: -12.01626284717128,
        },
        {
          lng: -77.04782723967516,
          lat: -12.01588518146005,
        },
        {
          lng: -77.04817114318382,
          lat: -12.01572705079206,
        },
        {
          lng: -77.04880162610375,
          lat: -12.01499118011918,
        },
        {
          lng: -77.04926765271598,
          lat: -12.01469314494809,
        },
        {
          lng: -77.04900293828294,
          lat: -12.01467322751624,
        },
        {
          lng: -77.04880124894595,
          lat: -12.01447415614488,
        },
        {
          lng: -77.04900351545109,
          lat: -12.01389678750274,
        },
        {
          lng: -77.04880343872946,
          lat: -12.01288543107928,
        },
        {
          lng: -77.04890326761097,
          lat: -12.01260496796339,
        },
        {
          lng: -77.04937002372306,
          lat: -12.01240410721341,
        },
        {
          lng: -77.04926890569232,
          lat: -12.01184849519285,
        },
        {
          lng: -77.04967559600898,
          lat: -12.01079396368451,
        },
        {
          lng: -77.0502858048895,
          lat: -12.01052257933591,
        },
        {
          lng: -77.05286062127219,
          lat: -12.01093603006972,
        },
      ],
    },
    {
      ubigeo: '150133',
      name: 'AH. VILLA JARDIN',
      poligonos: [
        {
          lng: -76.95143186515008,
          lat: -12.12187754246513,
        },
        {
          lng: -76.95142895955,
          lat: -12.12204176755442,
        },
        {
          lng: -76.95142368631016,
          lat: -12.1223124913812,
        },
        {
          lng: -76.95105977184092,
          lat: -12.1223751830781,
        },
        {
          lng: -76.95091410020429,
          lat: -12.12244976789131,
        },
        {
          lng: -76.95062149983411,
          lat: -12.1225524022324,
        },
        {
          lng: -76.95005687181711,
          lat: -12.12277877106982,
        },
        {
          lng: -76.94957823260297,
          lat: -12.1224123951056,
        },
        {
          lng: -76.94993604369773,
          lat: -12.12223606310607,
        },
        {
          lng: -76.95014900770313,
          lat: -12.12216385424703,
        },
        {
          lng: -76.95027929288052,
          lat: -12.12210289354376,
        },
        {
          lng: -76.95053762482353,
          lat: -12.121987524398,
        },
        {
          lng: -76.95054026689444,
          lat: -12.12194369497064,
        },
        {
          lng: -76.95069547948299,
          lat: -12.12193340781145,
        },
        {
          lng: -76.95073475400022,
          lat: -12.12190922912352,
        },
      ],
    },
    {
      ubigeo: '150133',
      name: 'ETAPA3',
      poligonos: [
        {
          lng: -76.95767975808003,
          lat: -12.1716091442666,
        },
        {
          lng: -76.9578488219473,
          lat: -12.17196028188143,
        },
        {
          lng: -76.95810053506496,
          lat: -12.17252820743674,
        },
        {
          lng: -76.957062639502,
          lat: -12.1730511219015,
        },
        {
          lng: -76.95706182641516,
          lat: -12.17291138702613,
        },
        {
          lng: -76.95712922830245,
          lat: -12.17272249194966,
        },
        {
          lng: -76.95729334465496,
          lat: -12.1724682692688,
        },
        {
          lng: -76.95720227825124,
          lat: -12.17240218174742,
        },
        {
          lng: -76.95624118832114,
          lat: -12.17292899009746,
        },
        {
          lng: -76.95612578608663,
          lat: -12.17309107976983,
        },
        {
          lng: -76.95529576473609,
          lat: -12.17348674809482,
        },
        {
          lng: -76.95500023504141,
          lat: -12.1735473013101,
        },
        {
          lng: -76.95497190569228,
          lat: -12.17349482032178,
        },
        {
          lng: -76.95485540432243,
          lat: -12.17348784017297,
        },
        {
          lng: -76.95488895105422,
          lat: -12.17343205109009,
        },
        {
          lng: -76.95489866646167,
          lat: -12.17303179597727,
        },
        {
          lng: -76.95489068692109,
          lat: -12.1728352660011,
        },
        {
          lng: -76.95494145896959,
          lat: -12.17258748802167,
        },
        {
          lng: -76.95519185354149,
          lat: -12.17249590168459,
        },
        {
          lng: -76.95523121579335,
          lat: -12.17220323527668,
        },
        {
          lng: -76.95542455301994,
          lat: -12.1720329424676,
        },
        {
          lng: -76.95536818120013,
          lat: -12.1718589760783,
        },
        {
          lng: -76.95536831283148,
          lat: -12.17171663582633,
        },
        {
          lng: -76.9563126085679,
          lat: -12.17142555127126,
        },
        {
          lng: -76.95733824051544,
          lat: -12.17098271054099,
        },
      ],
    },
    {
      ubigeo: '150133',
      name: 'ETAPA2',
      poligonos: [
        {
          lng: -76.95995933090668,
          lat: -12.16890156529594,
        },
        {
          lng: -76.96005068843145,
          lat: -12.16922133929696,
        },
        {
          lng: -76.96042956154632,
          lat: -12.17100905409476,
        },
        {
          lng: -76.95981499070477,
          lat: -12.17116545463897,
        },
        {
          lng: -76.95968160780599,
          lat: -12.17097780432128,
        },
        {
          lng: -76.95954446335944,
          lat: -12.1706411957391,
        },
        {
          lng: -76.95929697950746,
          lat: -12.17070185709019,
        },
        {
          lng: -76.95912441105999,
          lat: -12.17034675127553,
        },
        {
          lng: -76.95898569806789,
          lat: -12.17031305066887,
        },
        {
          lng: -76.95881651845694,
          lat: -12.17033112380459,
        },
        {
          lng: -76.95731618255054,
          lat: -12.17099011860656,
        },
        {
          lng: -76.95717468385573,
          lat: -12.17088881111253,
        },
        {
          lng: -76.9569916218252,
          lat: -12.17048174131963,
        },
        {
          lng: -76.95688968762828,
          lat: -12.16985050009134,
        },
        {
          lng: -76.95678088464985,
          lat: -12.16957008029075,
        },
        {
          lng: -76.95631671319374,
          lat: -12.16915654569578,
        },
        {
          lng: -76.9561137542928,
          lat: -12.16916683604752,
        },
        {
          lng: -76.95602466977579,
          lat: -12.16905449515728,
        },
        {
          lng: -76.95609134039013,
          lat: -12.16896751034744,
        },
        {
          lng: -76.95706790084891,
          lat: -12.16860018095123,
        },
        {
          lng: -76.95831664853624,
          lat: -12.16831601684435,
        },
        {
          lng: -76.95828069763785,
          lat: -12.16811586241917,
        },
        {
          lng: -76.95972708691336,
          lat: -12.16778473765915,
        },
      ],
    },
    {
      ubigeo: '150133',
      name: 'ETAPA1',
      poligonos: [
        {
          lng: -76.9589078929542,
          lat: -12.16424130026964,
        },
        {
          lng: -76.95900701898961,
          lat: -12.16470542154211,
        },
        {
          lng: -76.9593219394407,
          lat: -12.16621465659027,
        },
        {
          lng: -76.958620976918,
          lat: -12.16637302211066,
        },
        {
          lng: -76.95866496445457,
          lat: -12.16657501192805,
        },
        {
          lng: -76.95795026411574,
          lat: -12.16672544146324,
        },
        {
          lng: -76.95734901813276,
          lat: -12.16578441388479,
        },
        {
          lng: -76.95734121252816,
          lat: -12.16572982383036,
        },
        {
          lng: -76.95711576210823,
          lat: -12.16543762496734,
        },
        {
          lng: -76.95711391303682,
          lat: -12.16518539376816,
        },
        {
          lng: -76.95725181074916,
          lat: -12.16493226321531,
        },
        {
          lng: -76.95730954647257,
          lat: -12.16465904057033,
        },
        {
          lng: -76.95745363724821,
          lat: -12.16456157700852,
        },
        {
          lng: -76.95793358573317,
          lat: -12.16442853597978,
        },
        {
          lng: -76.95802863432563,
          lat: -12.16432519201211,
        },
        {
          lng: -76.95834459726524,
          lat: -12.16394909448218,
        },
        {
          lng: -76.95855604301154,
          lat: -12.16382862915019,
        },
        {
          lng: -76.95877752781115,
          lat: -12.16378427180028,
        },
      ],
    },
    {
      ubigeo: '150133',
      name: 'A.H LAS DUNAS',
      poligonos: [
        {
          lng: -76.98559621882619,
          lat: -12.16470703682965,
        },
        {
          lng: -76.98560385469372,
          lat: -12.16515336729505,
        },
        {
          lng: -76.98532546761457,
          lat: -12.16522395849156,
        },
        {
          lng: -76.98537917542161,
          lat: -12.16546521572226,
        },
        {
          lng: -76.98518899150945,
          lat: -12.16552997754527,
        },
        {
          lng: -76.98531150664367,
          lat: -12.16606415237412,
        },
        {
          lng: -76.98505970318705,
          lat: -12.16615484517193,
        },
        {
          lng: -76.98508702389196,
          lat: -12.16634057688267,
        },
        {
          lng: -76.98440804065854,
          lat: -12.16650055517482,
        },
        {
          lng: -76.98431892310286,
          lat: -12.16586559245374,
        },
        {
          lng: -76.98426174306998,
          lat: -12.16576184483016,
        },
        {
          lng: -76.98422036170155,
          lat: -12.1655724202499,
        },
        {
          lng: -76.98415618528746,
          lat: -12.16541329077785,
        },
        {
          lng: -76.98408561312723,
          lat: -12.1651240980522,
        },
      ],
    },
    {
      ubigeo: '150133',
      name: 'PACIFICO',
      poligonos: [
        {
          lng: -76.9576679783062,
          lat: -12.17578776674154,
        },
        {
          lng: -76.95768000860822,
          lat: -12.17587489826405,
        },
        {
          lng: -76.95723675424017,
          lat: -12.17596372356492,
        },
        {
          lng: -76.95727328612733,
          lat: -12.17608554260131,
        },
        {
          lng: -76.95649536981331,
          lat: -12.17625201708209,
        },
        {
          lng: -76.95647264586037,
          lat: -12.17619766277198,
        },
        {
          lng: -76.95552084799694,
          lat: -12.1763965284402,
        },
        {
          lng: -76.95502473360517,
          lat: -12.17678621789846,
        },
        {
          lng: -76.95465206373537,
          lat: -12.17618766195481,
        },
        {
          lng: -76.95499830757645,
          lat: -12.17570488172414,
        },
        {
          lng: -76.95493847417333,
          lat: -12.17547578569756,
        },
        {
          lng: -76.9549468535584,
          lat: -12.17521308897545,
        },
        {
          lng: -76.95488396119899,
          lat: -12.17502488071271,
        },
        {
          lng: -76.95489179449191,
          lat: -12.17479002570478,
        },
        {
          lng: -76.95485432954993,
          lat: -12.17463984693732,
        },
        {
          lng: -76.95480467579273,
          lat: -12.17433535519887,
        },
        {
          lng: -76.95478895864568,
          lat: -12.1740224130463,
        },
        {
          lng: -76.95476157808368,
          lat: -12.17374257155825,
        },
        {
          lng: -76.95487609818947,
          lat: -12.17348191451026,
        },
        {
          lng: -76.9549832028186,
          lat: -12.17347715766346,
        },
        {
          lng: -76.95499442921833,
          lat: -12.17354889798907,
        },
        {
          lng: -76.95530874486712,
          lat: -12.17347782236292,
        },
        {
          lng: -76.95611213312405,
          lat: -12.17308814775422,
        },
        {
          lng: -76.95622902289439,
          lat: -12.17292157170408,
        },
        {
          lng: -76.95721522099163,
          lat: -12.17239633803433,
        },
        {
          lng: -76.95729659396014,
          lat: -12.17247532373928,
        },
        {
          lng: -76.957139441244,
          lat: -12.1727100932952,
        },
        {
          lng: -76.95705781680934,
          lat: -12.1729018994532,
        },
        {
          lng: -76.95705246982872,
          lat: -12.17304998203838,
        },
        {
          lng: -76.95797717071763,
          lat: -12.17257507556092,
        },
        {
          lng: -76.9586598555333,
          lat: -12.17555460770362,
        },
      ],
    },
    {
      ubigeo: '150135',
      name: 'ZONA PERU IV',
      poligonos: [
        {
          lng: -77.08739606802176,
          lat: -12.03341293645021,
        },
        {
          lng: -77.08547985688807,
          lat: -12.02885669629566,
        },
        {
          lng: -77.09329468597089,
          lat: -12.02817536902922,
        },
        {
          lng: -77.09403717932709,
          lat: -12.02990370171802,
        },
        {
          lng: -77.09443977212281,
          lat: -12.02988291055862,
        },
        {
          lng: -77.0957152025359,
          lat: -12.03254054454394,
        },
      ],
    },
    {
      ubigeo: '150135',
      name: 'ZONA PERU III',
      poligonos: [
        {
          lng: -77.08898977658691,
          lat: -12.03731604573337,
        },
        {
          lng: -77.0883705827329,
          lat: -12.0374315163326,
        },
        {
          lng: -77.08514439685595,
          lat: -12.03678842391288,
        },
        {
          lng: -77.07809595172431,
          lat: -12.03546926592942,
        },
        {
          lng: -77.07833832921767,
          lat: -12.03464457831748,
        },
        {
          lng: -77.07829947988321,
          lat: -12.03377058998266,
        },
        {
          lng: -77.07661892760382,
          lat: -12.02931479160554,
        },
        {
          lng: -77.07849450597467,
          lat: -12.02924069643509,
        },
        {
          lng: -77.07972162754056,
          lat: -12.02890936575296,
        },
        {
          lng: -77.08627081519923,
          lat: -12.02558854877928,
        },
        {
          lng: -77.09129244140786,
          lat: -12.03786346124512,
        },
      ],
    },
    {
      ubigeo: '150135',
      name: 'ZONA PERU II',
      poligonos: [
        {
          lng: -77.0783871137024,
          lat: -12.03411139886142,
        },
        {
          lng: -77.0783459491644,
          lat: -12.03483949026995,
        },
        {
          lng: -77.07770093412056,
          lat: -12.03529982573261,
        },
        {
          lng: -77.07389178460545,
          lat: -12.03480880229818,
        },
        {
          lng: -77.0705356310883,
          lat: -12.03424036013169,
        },
        {
          lng: -77.06835530092347,
          lat: -12.03465683402132,
        },
        {
          lng: -77.06549550277212,
          lat: -12.03486964636129,
        },
        {
          lng: -77.06510051573927,
          lat: -12.03388211547577,
        },
        {
          lng: -77.06450490803475,
          lat: -12.02938316671322,
        },
        {
          lng: -77.06520042792825,
          lat: -12.02924532913743,
        },
        {
          lng: -77.06734196001804,
          lat: -12.02777911915226,
        },
        {
          lng: -77.06895823464274,
          lat: -12.02805614603918,
        },
        {
          lng: -77.07005740979636,
          lat: -12.02863230619739,
        },
        {
          lng: -77.07106908661945,
          lat: -12.02894406025102,
        },
        {
          lng: -77.07287439417752,
          lat: -12.02967444600976,
        },
        {
          lng: -77.07673379760267,
          lat: -12.02934772485353,
        },
      ],
    },
    {
      ubigeo: '150135',
      name: 'VALDIVIESO',
      poligonos: [
        {
          lng: -77.06854050190276,
          lat: -12.02540135166886,
        },
        {
          lng: -77.06825249310262,
          lat: -12.02570183167864,
        },
        {
          lng: -77.06855665859192,
          lat: -12.02609422270977,
        },
        {
          lng: -77.0685552070268,
          lat: -12.02639377069821,
        },
        {
          lng: -77.0673488619168,
          lat: -12.02749078414008,
        },
        {
          lng: -77.06749642149511,
          lat: -12.02791692450308,
        },
        {
          lng: -77.06700179271033,
          lat: -12.02805220605646,
        },
        {
          lng: -77.06655056100607,
          lat: -12.02826277754949,
        },
        {
          lng: -77.0659006098577,
          lat: -12.02870443362655,
        },
        {
          lng: -77.06515920686518,
          lat: -12.02928064232254,
        },
        {
          lng: -77.06480659316613,
          lat: -12.02942517566613,
        },
        {
          lng: -77.06411850302231,
          lat: -12.02957500933285,
        },
        {
          lng: -77.06385253083664,
          lat: -12.02824479590997,
        },
        {
          lng: -77.06306292167007,
          lat: -12.02748520970038,
        },
        {
          lng: -77.06286330546769,
          lat: -12.02714765136387,
        },
        {
          lng: -77.06280528544809,
          lat: -12.02668674697508,
        },
        {
          lng: -77.06261675670473,
          lat: -12.02618670850366,
        },
        {
          lng: -77.06212899973751,
          lat: -12.02570692169298,
        },
        {
          lng: -77.06245752277785,
          lat: -12.02417846005064,
        },
        {
          lng: -77.06371381702557,
          lat: -12.02306384095648,
        },
        {
          lng: -77.06474096907216,
          lat: -12.02411988386877,
        },
        {
          lng: -77.06584863600926,
          lat: -12.02309605513594,
        },
        {
          lng: -77.06632204733478,
          lat: -12.02357137207712,
        },
        {
          lng: -77.06649582540524,
          lat: -12.02344168973657,
        },
        {
          lng: -77.06705018351894,
          lat: -12.02386336757229,
        },
        {
          lng: -77.06735465500384,
          lat: -12.0239276643633,
        },
        {
          lng: -77.06764270272103,
          lat: -12.02374475675611,
        },
        {
          lng: -77.068592692897,
          lat: -12.02476178844659,
        },
      ],
    },
    {
      ubigeo: '150135',
      name: 'PALAO',
      poligonos: [
        {
          lng: -77.06286297727421,
          lat: -12.01505828459481,
        },
        {
          lng: -77.0630616687513,
          lat: -12.01536667132223,
        },
        {
          lng: -77.06301884267482,
          lat: -12.01577467873568,
        },
        {
          lng: -77.06328590593172,
          lat: -12.01632684504871,
        },
        {
          lng: -77.0634728196798,
          lat: -12.01685572465414,
        },
        {
          lng: -77.06387032869509,
          lat: -12.01755983835799,
        },
        {
          lng: -77.06366991387532,
          lat: -12.01758773337954,
        },
        {
          lng: -77.06360136390268,
          lat: -12.01775638365182,
        },
        {
          lng: -77.06344456647716,
          lat: -12.01782313072817,
        },
        {
          lng: -77.06346060418099,
          lat: -12.01797979055666,
        },
        {
          lng: -77.06328818223929,
          lat: -12.01808105541136,
        },
        {
          lng: -77.06298263252904,
          lat: -12.0180232568525,
        },
        {
          lng: -77.06288401465687,
          lat: -12.01809068075394,
        },
        {
          lng: -77.0627292342912,
          lat: -12.01802969351364,
        },
        {
          lng: -77.06202577702386,
          lat: -12.01791835027583,
        },
        {
          lng: -77.06169352155649,
          lat: -12.01721365114343,
        },
        {
          lng: -77.06162951450996,
          lat: -12.01706436169723,
        },
        {
          lng: -77.06209054232723,
          lat: -12.01708515244347,
        },
        {
          lng: -77.06235654573592,
          lat: -12.01697852953788,
        },
        {
          lng: -77.06238072491598,
          lat: -12.01676900576251,
        },
        {
          lng: -77.06204892959349,
          lat: -12.01564019005681,
        },
        {
          lng: -77.06203036858885,
          lat: -12.01517873972971,
        },
        {
          lng: -77.06199808193487,
          lat: -12.01478383266702,
        },
        {
          lng: -77.06210073248023,
          lat: -12.01404366081406,
        },
        {
          lng: -77.06224085380396,
          lat: -12.01382877297296,
        },
        {
          lng: -77.0625789881132,
          lat: -12.01399742730206,
        },
        {
          lng: -77.06267235748815,
          lat: -12.01448081386639,
        },
        {
          lng: -77.06274432535251,
          lat: -12.01463240844931,
        },
      ],
    },
    {
      ubigeo: '150135',
      name: 'LAMPA DE ORO',
      poligonos: [
        {
          lng: -77.06210073248023,
          lat: -12.01404366081406,
        },
        {
          lng: -77.06224085380396,
          lat: -12.01382877297296,
        },
        {
          lng: -77.0625789881132,
          lat: -12.01399742730206,
        },
        {
          lng: -77.06267235748815,
          lat: -12.01448081386639,
        },
        {
          lng: -77.06274432535251,
          lat: -12.01463240844931,
        },
        {
          lng: -77.06286297727421,
          lat: -12.01505828459481,
        },
        {
          lng: -77.0630616687513,
          lat: -12.01536667132223,
        },
        {
          lng: -77.06301884267482,
          lat: -12.01577467873568,
        },
        {
          lng: -77.06328590593172,
          lat: -12.01632684504871,
        },
        {
          lng: -77.0634728196798,
          lat: -12.01685572465414,
        },
        {
          lng: -77.06387032869509,
          lat: -12.01755983835799,
        },
        {
          lng: -77.06366991387532,
          lat: -12.01758773337954,
        },
        {
          lng: -77.06360136390268,
          lat: -12.01775638365182,
        },
        {
          lng: -77.06344456647716,
          lat: -12.01782313072817,
        },
        {
          lng: -77.06346060418099,
          lat: -12.01797979055666,
        },
        {
          lng: -77.06328818223929,
          lat: -12.01808105541136,
        },
        {
          lng: -77.06298263252904,
          lat: -12.0180232568525,
        },
        {
          lng: -77.06288401465687,
          lat: -12.01809068075394,
        },
        {
          lng: -77.0627292342912,
          lat: -12.01802969351364,
        },
        {
          lng: -77.06202577702386,
          lat: -12.01791835027583,
        },
        {
          lng: -77.06169352155649,
          lat: -12.01721365114343,
        },
        {
          lng: -77.06162951450996,
          lat: -12.01706436169723,
        },
        {
          lng: -77.06209054232723,
          lat: -12.01708515244347,
        },
        {
          lng: -77.06235654573592,
          lat: -12.01697852953788,
        },
        {
          lng: -77.06238072491598,
          lat: -12.01676900576251,
        },
        {
          lng: -77.06204892959349,
          lat: -12.01564019005681,
        },
        {
          lng: -77.06203036858885,
          lat: -12.01517873972971,
        },
        {
          lng: -77.06199808193487,
          lat: -12.01478383266702,
        },
      ],
    },
    {
      ubigeo: '150135',
      name: 'CAQUETA',
      poligonos: [
        {
          lng: -77.04997030360587,
          lat: -12.03373924704754,
        },
        {
          lng: -77.04849101735806,
          lat: -12.03428023777088,
        },
        {
          lng: -77.04878932222208,
          lat: -12.0351480359268,
        },
        {
          lng: -77.04637622050261,
          lat: -12.03570838164959,
        },
        {
          lng: -77.04372458360939,
          lat: -12.03639581909325,
        },
        {
          lng: -77.0438129122526,
          lat: -12.03528792747091,
        },
        {
          lng: -77.04422199923339,
          lat: -12.03051177471457,
        },
        {
          lng: -77.04680432759757,
          lat: -12.03064582975268,
        },
        {
          lng: -77.0497686024942,
          lat: -12.03023103860838,
        },
        {
          lng: -77.05105463129574,
          lat: -12.02982289348655,
        },
        {
          lng: -77.05112439272463,
          lat: -12.03010526136734,
        },
        {
          lng: -77.05087864705486,
          lat: -12.03312367020806,
        },
      ],
    },
    {
      ubigeo: '150142',
      name: 'URB BARRIO 2',
      poligonos: [
        {
          lng: -76.92120483531794,
          lat: -12.21884558718303,
        },
        {
          lng: -76.92185447439967,
          lat: -12.21651588769639,
        },
        {
          lng: -76.92184031652936,
          lat: -12.21610223832328,
        },
        {
          lng: -76.92173796728761,
          lat: -12.21577043122469,
        },
        {
          lng: -76.92206521061246,
          lat: -12.21534753862032,
        },
        {
          lng: -76.92209232161639,
          lat: -12.21502920201726,
        },
        {
          lng: -76.92711394383588,
          lat: -12.21791239952967,
        },
        {
          lng: -76.9225334665718,
          lat: -12.22551544187373,
        },
        {
          lng: -76.92034859839424,
          lat: -12.22427087560073,
        },
        {
          lng: -76.9198219784628,
          lat: -12.22408117939836,
        },
        {
          lng: -76.9198693164197,
          lat: -12.22369786757807,
        },
        {
          lng: -76.92007056745527,
          lat: -12.22289135863825,
        },
        {
          lng: -76.92050019741673,
          lat: -12.22135335509981,
        },
      ],
    },
    {
      ubigeo: '150142',
      name: 'SECTOR2',
      poligonos: [
        {
          lng: -76.91884583606345,
          lat: -12.24158093819843,
        },
        {
          lng: -76.91799752191241,
          lat: -12.2429800061689,
        },
        {
          lng: -76.91381361059875,
          lat: -12.24048334771432,
        },
        {
          lng: -76.91557498501297,
          lat: -12.23728002486165,
        },
        {
          lng: -76.91621143240536,
          lat: -12.23620470410034,
        },
        {
          lng: -76.91918168989918,
          lat: -12.23794365300277,
        },
        {
          lng: -76.91977361022855,
          lat: -12.23837106769889,
        },
        {
          lng: -76.92077436307392,
          lat: -12.23922874852576,
        },
      ],
    },
    {
      ubigeo: '150142',
      name: 'SECTOR1',
      poligonos: [
        {
          lng: -76.92555303941987,
          lat: -12.22020795447844,
        },
        {
          lng: -76.92463213434257,
          lat: -12.22191353243947,
        },
        {
          lng: -76.92271985685592,
          lat: -12.22540429484593,
        },
        {
          lng: -76.91859638629573,
          lat: -12.23336913877453,
        },
        {
          lng: -76.92180552515819,
          lat: -12.23473442229557,
        },
        {
          lng: -76.9238812897747,
          lat: -12.23586488150849,
        },
        {
          lng: -76.92121907800295,
          lat: -12.23876164943438,
        },
        {
          lng: -76.92027013481423,
          lat: -12.23885212776843,
        },
        {
          lng: -76.91884151885685,
          lat: -12.23769959970654,
        },
        {
          lng: -76.91652647265573,
          lat: -12.23636786842589,
        },
        {
          lng: -76.91810558500957,
          lat: -12.23343330971566,
        },
        {
          lng: -76.91589500137377,
          lat: -12.23187502362915,
        },
        {
          lng: -76.91573853219936,
          lat: -12.23138991426078,
        },
        {
          lng: -76.91569412437816,
          lat: -12.23077561556781,
        },
        {
          lng: -76.91600811171477,
          lat: -12.22891719075579,
        },
        {
          lng: -76.91591898171706,
          lat: -12.22856868778877,
        },
        {
          lng: -76.9153578845296,
          lat: -12.22717832756306,
        },
        {
          lng: -76.91764709037031,
          lat: -12.22622167529981,
        },
        {
          lng: -76.91856191426758,
          lat: -12.22560508080252,
        },
        {
          lng: -76.91931787128155,
          lat: -12.22445224937492,
        },
        {
          lng: -76.9217964724169,
          lat: -12.21468256942159,
        },
        {
          lng: -76.92676786015366,
          lat: -12.21762946801345,
        },
      ],
    },
    {
      ubigeo: '150142',
      name: 'ETAPA2',
      poligonos: [
        {
          lng: -76.92314050702262,
          lat: -12.23608100366236,
        },
        {
          lng: -76.91807287647005,
          lat: -12.23305000970876,
        },
        {
          lng: -76.92025733770485,
          lat: -12.22937745219822,
        },
        {
          lng: -76.92536102280869,
          lat: -12.23233766427184,
        },
      ],
    },
    {
      ubigeo: '150142',
      name: 'ETAPA1',
      poligonos: [
        {
          lng: -76.92539972626287,
          lat: -12.23235426812447,
        },
        {
          lng: -76.920260407221,
          lat: -12.22936601521426,
        },
        {
          lng: -76.92253754200216,
          lat: -12.22550020343712,
        },
        {
          lng: -76.92769121105341,
          lat: -12.2284917531459,
        },
      ],
    },
    {
      ubigeo: '150143',
      name: 'QUEBRADA PARAISO',
      poligonos: [
      {lng:-76.92437908729532,lat:-12.14421258117433},
      {lng:-76.92440348348221,lat:-12.14434845461424},
      {lng:-76.92450903382941,lat:-12.14449009431858},
      {lng:-76.92492257239392,lat:-12.14488670981527},
      {lng:-76.92407492298017,lat:-12.14639360314578},
      {lng:-76.9232676341633,lat:-12.14588541128245},
      {lng:-76.9230358568895,lat:-12.14563205532432},
      {lng:-76.92283268625242,lat:-12.14522718087474},
      {lng:-76.92271099443528,lat:-12.14485985727168},
      {lng:-76.92271593476636,lat:-12.14455866539717},
      {lng:-76.92279801961192,lat:-12.14413419303864},
      {lng:-76.92283803570572,lat:-12.14369280243973},
      {lng:-76.92303407221979,lat:-12.14177089059615},
      {lng:-76.92359704309513,lat:-12.14186688946266},
      {lng:-76.92405968848291,lat:-12.14223054685848},
      {lng:-76.92434859486181,lat:-12.14238152667403},
      {lng:-76.92471362589151,lat:-12.14267846254207},
      ],
    },

    {
            ubigeo: '15845',
            name: 'PLAYAS DEL SUR',
            poligonos: [
    { lng: -76.75252860119058, lat: -12.43449713628171 },
    { lng: -76.71632957868137, lat: -12.4907568164076 },
    { lng: -76.70498026296183, lat: -12.51985461424439 },
    { lng: -76.66942966737851, lat: -12.5419238283832 },
    { lng: -76.68834580274444, lat: -12.58216747133254 },
    { lng: -76.64561202635521, lat: -12.62197094803924 },
    { lng: -76.62190678802834, lat: -12.6267605416324 },
    { lng: -76.59528980290551, lat: -12.66925019496129 },
    { lng: -76.57106949120059, lat: -12.70349196302048 },
    { lng: -76.49011660206337, lat: -12.73221449165757 },
    { lng: -76.45244522585406, lat: -12.74721584045697 },
    { lng: -76.35436028248422, lat: -12.68203847919184 },
    { lng: -76.32245569114711, lat: -12.59374866897001 },
    { lng: -76.42731270780892, lat: -12.59492287513261 },
    { lng: -76.48655514182057, lat: -12.5146788109811 },
    { lng: -76.5969655922294, lat: -12.44220048039216 },
    { lng: -76.74025628901929, lat: -12.22144370703876 },
    { lng: -76.81713514050108, lat: -12.30281513418627 },
    { lng: -76.81487137646599, lat: -12.30507392138387 },
    { lng: -76.81878399037184, lat: -12.30788011135773 },
    { lng: -76.82098487357919, lat: -12.31018697697664 },
    { lng: -76.8182612156926, lat: -12.31277872642675 },
    { lng: -76.81964754841944, lat: -12.31426367773952 },
    { lng: -76.82217279114779, lat: -12.31605557378944 },
    { lng: -76.82268495649059, lat: -12.31814937646825 },
    { lng: -76.82706328020937, lat: -12.32083078678756 },
    { lng: -76.8289620455102, lat: -12.32152299651341 },
    { lng: -76.8313704392276, lat: -12.31811499793072 },
    { lng: -76.83342117328453, lat: -12.31987342964487 },
    { lng: -76.83408795141476, lat: -12.31981349923754 },
    { lng: -76.83487899778467, lat: -12.3195956653688 },
    { lng: -76.83755642487702, lat: -12.32184027247229 },
    { lng: -76.83791643044742, lat: -12.32398104427175 },
    { lng: -76.81844077393175, lat: -12.35586533270467 },
    { lng: -76.78254262615904, lat: -12.41459380171691 },
    { lng: -76.75252860119058, lat: -12.43449713628171 }
               ]
               },
    {
            ubigeo: '040108',
            name: 'LA JOYA AREQUIPA',
            poligonos: [
          {lat: -16.40089213510821, lng: -71.87631341961058},
          {lat: -16.43981416363254, lng: -71.91010391390209},
          {lat: -16.44425820239546, lng: -71.95027941085291},
          {lat: -16.48815479598368, lng: -71.94494317769094},
          {lat: -16.52325866199572, lng: -71.96957212883324},
          {lat: -16.57406321838337, lng: -71.96812673726633},
          {lat: -16.60759954006096, lng: -71.96579781267369},
          {lat: -16.66407416389404, lng: -71.95269676545108},
          {lat: -16.69150809509201, lng: -71.98953361593799},
          {lat: -16.76049222531435, lng: -71.9424824468635},
          {lat: -16.740345948152, lng: -71.83771375991519},
          {lat: -16.62851925852758, lng: -71.80571324167121},
          {lat: -16.53111394290215, lng: -71.76477165542696},
          {lat: -16.51532990112639, lng: -71.78253765387026},
          {lat: -16.5010494545214, lng: -71.80026995150747},
          {lat: -16.47781698587203, lng: -71.80102435165992},
          {lat: -16.45236507928842, lng: -71.79790127749834},
          {lat: -16.42201686455174, lng: -71.79999961514753},
          {lat: -16.41215953448711, lng: -71.8144213875062},
          {lat: -16.40089213510821, lng: -71.87631341961058}
               ]
               },
    {
      ubigeo: '150143',
      name: 'A.H. VALLECITO ALTO',
      poligonos: [
        {
          lng: -76.94976191017469,
          lat: -12.14159441551591,
        },
        {
          lng: -76.95055560837775,
          lat: -12.14480139325669,
        },
        {
          lng: -76.95003948553988,
          lat: -12.1449582860699,
        },
        {
          lng: -76.95012701706429,
          lat: -12.14548264765341,
        },
        {
          lng: -76.94929075462338,
          lat: -12.14606143033082,
        },
        {
          lng: -76.94908013165389,
          lat: -12.14592420032986,
        },
        {
          lng: -76.94875891764904,
          lat: -12.14551953636546,
        },
        {
          lng: -76.94821247961819,
          lat: -12.14530117300174,
        },
        {
          lng: -76.94768334823215,
          lat: -12.1453360800201,
        },
        {
          lng: -76.94735135269735,
          lat: -12.14526183366522,
        },
        {
          lng: -76.94721922354596,
          lat: -12.14580750001908,
        },
        {
          lng: -76.94692537342208,
          lat: -12.1458530737691,
        },
        {
          lng: -76.9465146383726,
          lat: -12.14575939846264,
        },
        {
          lng: -76.94654971956763,
          lat: -12.14542759432162,
        },
        {
          lng: -76.9455116827373,
          lat: -12.14523344461934,
        },
        {
          lng: -76.9454158008953,
          lat: -12.14562363940922,
        },
        {
          lng: -76.94520584289013,
          lat: -12.14559861575657,
        },
        {
          lng: -76.94515159031216,
          lat: -12.1454967658724,
        },
        {
          lng: -76.94518620546002,
          lat: -12.1451849727774,
        },
        {
          lng: -76.94463175424555,
          lat: -12.14509119068399,
        },
        {
          lng: -76.94454463383369,
          lat: -12.14481213524685,
        },
        {
          lng: -76.94458719042487,
          lat: -12.14463036716534,
        },
        {
          lng: -76.94441009406091,
          lat: -12.14454649069412,
        },
        {
          lng: -76.9440855108342,
          lat: -12.14450578725845,
        },
        {
          lng: -76.94379085346544,
          lat: -12.14437403275286,
        },
        {
          lng: -76.94354621908306,
          lat: -12.14472156243145,
        },
        {
          lng: -76.9433249359798,
          lat: -12.14463860411835,
        },
        {
          lng: -76.94314132085808,
          lat: -12.14489236607098,
        },
        {
          lng: -76.94289795738821,
          lat: -12.14475585628466,
        },
        {
          lng: -76.94264705604527,
          lat: -12.14500826459194,
        },
        {
          lng: -76.9424164321297,
          lat: -12.14531005533706,
        },
        {
          lng: -76.94220117261597,
          lat: -12.14524255808695,
        },
        {
          lng: -76.94176035880922,
          lat: -12.14501293942279,
        },
        {
          lng: -76.94158522314898,
          lat: -12.14523002254506,
        },
        {
          lng: -76.94113087618604,
          lat: -12.1449446866027,
        },
        {
          lng: -76.94052578698785,
          lat: -12.14461042246956,
        },
        {
          lng: -76.9406086290761,
          lat: -12.14441080624742,
        },
        {
          lng: -76.94109011852812,
          lat: -12.14391715751388,
        },
        {
          lng: -76.94094904808291,
          lat: -12.14380999824449,
        },
        {
          lng: -76.94109402140631,
          lat: -12.14367461794924,
        },
        {
          lng: -76.94136240893394,
          lat: -12.14378531866708,
        },
        {
          lng: -76.94171597130435,
          lat: -12.14362981040171,
        },
        {
          lng: -76.94190435205289,
          lat: -12.14377552220843,
        },
        {
          lng: -76.942241576789,
          lat: -12.14346072330347,
        },
        {
          lng: -76.94211958115527,
          lat: -12.14337542385188,
        },
        {
          lng: -76.94198149657632,
          lat: -12.14291854332697,
        },
        {
          lng: -76.9417715533775,
          lat: -12.14279622627852,
        },
        {
          lng: -76.9410414878357,
          lat: -12.14266098275966,
        },
        {
          lng: -76.9404466372512,
          lat: -12.142874235056,
        },
        {
          lng: -76.94021016867367,
          lat: -12.14282556589907,
        },
        {
          lng: -76.93983151459662,
          lat: -12.1430031016214,
        },
        {
          lng: -76.9395973072355,
          lat: -12.14402058820714,
        },
        {
          lng: -76.9393140232667,
          lat: -12.1439687391237,
        },
        {
          lng: -76.93919365801007,
          lat: -12.14452751493629,
        },
        {
          lng: -76.93859688583206,
          lat: -12.14522167994288,
        },
        {
          lng: -76.93803889132134,
          lat: -12.14514365294313,
        },
        {
          lng: -76.9379365294637,
          lat: -12.14531056089113,
        },
        {
          lng: -76.93792295185132,
          lat: -12.14558735221251,
        },
        {
          lng: -76.93750654576391,
          lat: -12.14604695376099,
        },
        {
          lng: -76.93725057306071,
          lat: -12.14637984828305,
        },
        {
          lng: -76.9368604194023,
          lat: -12.14613657472981,
        },
        {
          lng: -76.93669114276605,
          lat: -12.14594718839125,
        },
        {
          lng: -76.93710332284212,
          lat: -12.14540877644876,
        },
        {
          lng: -76.93690171286009,
          lat: -12.14538975905859,
        },
        {
          lng: -76.93682829848501,
          lat: -12.14485516197269,
        },
        {
          lng: -76.93672681511532,
          lat: -12.14459720359104,
        },
        {
          lng: -76.93717648524454,
          lat: -12.14471192310495,
        },
        {
          lng: -76.93721282249044,
          lat: -12.14458178314741,
        },
        {
          lng: -76.93727684172933,
          lat: -12.14456744943514,
        },
        {
          lng: -76.93728543682833,
          lat: -12.14449105967667,
        },
        {
          lng: -76.93735216947302,
          lat: -12.14450311591252,
        },
        {
          lng: -76.93749824487999,
          lat: -12.14408174612501,
        },
        {
          lng: -76.93766469341772,
          lat: -12.1435462944777,
        },
        {
          lng: -76.93786381500998,
          lat: -12.1435786343946,
        },
        {
          lng: -76.9378574517771,
          lat: -12.14339531665685,
        },
        {
          lng: -76.93778309827557,
          lat: -12.143304607052,
        },
        {
          lng: -76.93784080344054,
          lat: -12.14291928245498,
        },
        {
          lng: -76.93724436425666,
          lat: -12.14277480646296,
        },
        {
          lng: -76.9353775621939,
          lat: -12.14224443324733,
        },
        {
          lng: -76.93547183288409,
          lat: -12.14195545101939,
        },
        {
          lng: -76.93554417014148,
          lat: -12.14164949528373,
        },
        {
          lng: -76.93570361184253,
          lat: -12.14081693717284,
        },
        {
          lng: -76.93565956940452,
          lat: -12.14075399156687,
        },
        {
          lng: -76.93578377337467,
          lat: -12.14002691708689,
        },
        {
          lng: -76.93664226938454,
          lat: -12.14026004907316,
        },
        {
          lng: -76.93659552830951,
          lat: -12.14043538451091,
        },
        {
          lng: -76.93676518178088,
          lat: -12.14046247768337,
        },
        {
          lng: -76.93686038350017,
          lat: -12.14069174842878,
        },
        {
          lng: -76.93712546595074,
          lat: -12.14068864206085,
        },
        {
          lng: -76.93735108960362,
          lat: -12.14074684160907,
        },
        {
          lng: -76.93764540423017,
          lat: -12.14078165758229,
        },
        {
          lng: -76.93779152446002,
          lat: -12.14068757371341,
        },
        {
          lng: -76.93800164473367,
          lat: -12.14075793432519,
        },
        {
          lng: -76.93808216531012,
          lat: -12.14062189613641,
        },
        {
          lng: -76.9383127664037,
          lat: -12.14068496817722,
        },
        {
          lng: -76.9383699676359,
          lat: -12.14054411601123,
        },
        {
          lng: -76.9379577819228,
          lat: -12.14043073367665,
        },
        {
          lng: -76.93756315226412,
          lat: -12.14014892053538,
        },
        {
          lng: -76.93770187234188,
          lat: -12.13998987194455,
        },
        {
          lng: -76.93785806314808,
          lat: -12.1399518343304,
        },
        {
          lng: -76.93775716750184,
          lat: -12.13972366108518,
        },
        {
          lng: -76.93797316789652,
          lat: -12.13960427356355,
        },
        {
          lng: -76.93805681828081,
          lat: -12.13946135524358,
        },
        {
          lng: -76.93833193728608,
          lat: -12.13932965210263,
        },
        {
          lng: -76.9387869933062,
          lat: -12.1392473298358,
        },
        {
          lng: -76.9388048422558,
          lat: -12.13931502858987,
        },
        {
          lng: -76.9389809523847,
          lat: -12.13932423901751,
        },
        {
          lng: -76.93916688789784,
          lat: -12.13926722934299,
        },
        {
          lng: -76.93929143560999,
          lat: -12.13937862815479,
        },
        {
          lng: -76.93927414762369,
          lat: -12.13946765150199,
        },
        {
          lng: -76.93965521105906,
          lat: -12.13952304288629,
        },
        {
          lng: -76.93963893584086,
          lat: -12.13962410757203,
        },
        {
          lng: -76.94035677683341,
          lat: -12.13972955442348,
        },
        {
          lng: -76.94038710073674,
          lat: -12.13948627521593,
        },
        {
          lng: -76.93781021455742,
          lat: -12.13790246776212,
        },
        {
          lng: -76.93788785988903,
          lat: -12.13763118162915,
        },
        {
          lng: -76.9380465886845,
          lat: -12.13738945554549,
        },
        {
          lng: -76.9388798588834,
          lat: -12.13783749745936,
        },
        {
          lng: -76.93921648675958,
          lat: -12.13807462542552,
        },
        {
          lng: -76.93988432052149,
          lat: -12.13843091364516,
        },
        {
          lng: -76.94045261986267,
          lat: -12.13864338482708,
        },
        {
          lng: -76.94112202951966,
          lat: -12.13892270973855,
        },
        {
          lng: -76.94107374564418,
          lat: -12.13917464567377,
        },
        {
          lng: -76.94145148406787,
          lat: -12.1392632845432,
        },
        {
          lng: -76.94209841384603,
          lat: -12.13930764931771,
        },
        {
          lng: -76.9429149474629,
          lat: -12.13920558157141,
        },
        {
          lng: -76.9433828059283,
          lat: -12.1394342797813,
        },
        {
          lng: -76.94349641977472,
          lat: -12.13923684139317,
        },
        {
          lng: -76.94401676130799,
          lat: -12.1388760988238,
        },
        {
          lng: -76.9443090344492,
          lat: -12.13903799396458,
        },
        {
          lng: -76.94443328055073,
          lat: -12.13926307960821,
        },
        {
          lng: -76.94491341102173,
          lat: -12.13958747465,
        },
        {
          lng: -76.94634093042326,
          lat: -12.13984962413395,
        },
        {
          lng: -76.9459306437703,
          lat: -12.14029153886744,
        },
        {
          lng: -76.94791896835234,
          lat: -12.14251065818172,
        },
        {
          lng: -76.94612846502716,
          lat: -12.14050205844289,
        },
        {
          lng: -76.94598279544476,
          lat: -12.14133038943084,
        },
        {
          lng: -76.94586740456654,
          lat: -12.14133036416416,
        },
        {
          lng: -76.94583759526788,
          lat: -12.1414758858186,
        },
        {
          lng: -76.94591551843313,
          lat: -12.14151011652592,
        },
        {
          lng: -76.9457794870806,
          lat: -12.14206272520536,
        },
      ],
    },
  ],
};

// // Loop through each region
// DATA_API_GOOGLE = DATA_API_GOOGLE['lista-poligonos'].forEach((region) => {
//   // Loop through each set of coordinates in the region
//   region.poligonos.forEach((coordinate) => {
//     // Convert 'lat' and 'lng' strings to numbers
//     coordinate.lat = parseFloat(coordinate.lat);
//     coordinate.lng = parseFloat(coordinate.lng);
//   });
// });
